
// window.__xnPricing = window.__xnPricing || (function() {

//     // v8: maps Shopify currency codes to a BCP-47 locale whose number-formatting
//     // rules match how Shopify itself renders that currency on the storefront.
//     // This is used by formatAmount() so the displayed price uses the right
//     // decimal separator (comma for EUR/PLN/BRL/…, dot for USD/GBP/INR/…).
//     var CURRENCY_LOCALE_MAP = {
//         // Comma-decimal currencies
//         'EUR': 'de-DE', 'PLN': 'pl-PL', 'SEK': 'sv-SE', 'NOK': 'nb-NO',
//         'DKK': 'da-DK', 'HUF': 'hu-HU', 'CZK': 'cs-CZ', 'RON': 'ro-RO',
//         'BGN': 'bg-BG', 'HRK': 'hr-HR', 'RUB': 'ru-RU', 'UAH': 'uk-UA',
//         'BRL': 'pt-BR', 'ARS': 'es-AR', 'COP': 'es-CO', 'CLP': 'es-CL',
//         'VND': 'vi-VN', 'IDR': 'id-ID', 'ISK': 'is-IS', 'TRY': 'tr-TR',
//         // Dot-decimal currencies
//         'USD': 'en-US', 'GBP': 'en-GB', 'AUD': 'en-AU', 'CAD': 'en-CA',
//         'NZD': 'en-NZ', 'SGD': 'en-SG', 'HKD': 'en-HK', 'ZAR': 'en-ZA',
//         'MXN': 'es-MX', 'CHF': 'de-CH', 'JPY': 'ja-JP', 'KRW': 'ko-KR',
//         'INR': 'en-IN', 'PKR': 'en-PK', 'BDT': 'bn-BD', 'LKR': 'si-LK',
//         'AED': 'ar-AE', 'SAR': 'ar-SA', 'QAR': 'ar-QA', 'KWD': 'ar-KW',
//         'BHD': 'ar-BH', 'OMR': 'ar-OM', 'JOD': 'ar-JO', 'ILS': 'he-IL',
//         'THB': 'th-TH', 'MYR': 'ms-MY', 'PHP': 'en-PH', 'TWD': 'zh-TW',
//         'CNY': 'zh-CN', 'EGP': 'ar-EG', 'MAD': 'fr-MA', 'NGN': 'en-NG',
//         'GHS': 'en-GH', 'KES': 'sw-KE', 'TZS': 'sw-TZ', 'UGX': 'sw-UG',
//         'ETB': 'am-ET', 'CRC': 'es-CR', 'PEN': 'es-PE', 'UYU': 'es-UY',
//         'BOB': 'es-BO', 'PYG': 'es-PY', 'DOP': 'es-DO', 'GTQ': 'es-GT',
//         'HNL': 'es-HN', 'NIO': 'es-NI', 'PAB': 'es-PA', 'VEF': 'es-VE',
//     };

//     // v8: locale-aware price parser.
//     function getPriceValue(value) {
//         if (typeof value === 'number') return isFinite(value) ? value : 0;
//         if (!value) return 0;
//         var s = String(value).replace(/[^0-9.,-]/g, '');
//         if (!s) return 0;
//         var neg = s.charAt(0) === '-';
//         s = s.replace(/-/g, '');
//         var hasDot   = s.indexOf('.') !== -1;
//         var hasComma = s.indexOf(',') !== -1;
//         var decimalSep = '';
//         if (hasDot && hasComma) {
//             decimalSep = s.lastIndexOf(',') > s.lastIndexOf('.') ? ',' : '.';
//         } else if (hasDot || hasComma) {
//             var sep   = hasDot ? '.' : ',';
//             var parts = s.split(sep);
//             if (parts.length === 2 && parts[1].length > 0 && parts[1].length <= 2) {
//                 decimalSep = sep;
//             }
//         }
//         if (decimalSep) {
//             var thousandsSep = decimalSep === ',' ? '.' : ',';
//             s = s.split(thousandsSep).join('').replace(decimalSep, '.');
//         } else {
//             s = s.replace(/[.,]/g, '');
//         }
//         var n = parseFloat(s);
//         if (isNaN(n)) return 0;
//         return neg ? -n : n;
//     }

//     function getPriceElMoneyString() {
//         var priceEl = document.querySelector(
//             '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
//         ) || document.querySelector('.custom_product_price');
//         return priceEl ? priceEl.getAttribute('data-original-money') || priceEl.textContent.trim() : '';
//     }

//     function parseCurrencyWrapper() {
//         var s = getPriceElMoneyString();
//         if (!s) return { prefix: '₹', suffix: '' };
//         var prefixMatch = s.match(/^([^0-9]*)/);
//         var suffixMatch = s.match(/([^0-9]*)$/);
//         var prefix = prefixMatch ? prefixMatch[1] : '';
//         var suffix = suffixMatch ? suffixMatch[1] : '';
//         suffix = suffix.replace(/^[\s,.'-]+/, '');
//         return { prefix: prefix, suffix: suffix };
//     }

//     function getStorefrontCurrencySymbol() {
//         return parseCurrencyWrapper().prefix || '₹';
//     }

//     // v8: reads the active currency code from Shopify's global or a data attribute.
//     function getStorefrontCurrencyCode() {
//         if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
//             return window.Shopify.currency.active;
//         }
//         var priceEl = document.querySelector(
//             '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
//         ) || document.querySelector('.custom_product_price');
//         return (priceEl && priceEl.getAttribute('data-currency')) || 'INR';
//     }

//     function formatAmount(amount, decimalPlaces) {
//         var dp = (decimalPlaces === undefined) ? 2 : decimalPlaces;
//         var code   = getStorefrontCurrencyCode();
//         var locale = CURRENCY_LOCALE_MAP[code] || 'en-US';
//         return new Intl.NumberFormat(locale, {
//             minimumFractionDigits: dp,
//             maximumFractionDigits: dp
//         }).format(amount);
//     }

//     function formatPriceLabel(price) {
//         if (!price || price <= 0) return '';
//         var wrap   = parseCurrencyWrapper();
//         var number = formatAmount(price);
//         var formatted = wrap.prefix + number + (wrap.suffix ? ' ' + wrap.suffix : '');
//         return ' (+' + formatted + ')';
//     }

//     function splitPriceInTwo(total) {
//         var totalMinor = Math.round((total || 0) * 100);
//         var first = Math.ceil(totalMinor / 2);
//         return [first / 100, (totalMinor - first) / 100];
//     }

//     function buildPersonalisationLabels(opts) {
//         var labels = { 'Personalisation Option': opts.title || 'Personalisation' };
//         // v14: prefer an authoritative total (e.g. Shopify's own final_line_price
//         // for the linked add-on line) over recomputing unitPrice*quantity
//         // ourselves — the latter can go stale for one sync cycle if the
//         // add-on's quantity and the main item's quantity are momentarily out
//         // of step (e.g. right after a currency/country switch reload).
//         var total = (typeof opts.total === 'number') ? opts.total : (opts.unitPrice || 0) * (opts.quantity || 1);
//         if (opts.mode === 'one') {
//             labels['Side 1 Text'] = (opts.sideOneText || '') + formatPriceLabel(total);
//         } else if (opts.mode === 'two') {
//             var halves = splitPriceInTwo(total);
//             labels['Side 1 Text'] = (opts.sideOneText || '') + formatPriceLabel(halves[0]);
//             labels['Side 2 Text'] = (opts.sideTwoText || '') + formatPriceLabel(halves[1]);
//         }
//         return labels;
//     }

//     return {
//         getPriceValue:               getPriceValue,
//         getStorefrontCurrencySymbol: getStorefrontCurrencySymbol,
//         getStorefrontCurrencyCode:   getStorefrontCurrencyCode,
//         parseCurrencyWrapper:        parseCurrencyWrapper,
//         formatAmount:                formatAmount,
//         formatPriceLabel:            formatPriceLabel,
//         splitPriceInTwo:             splitPriceInTwo,
//         buildPersonalisationLabels:  buildPersonalisationLabels
//     };
// })();

// (function() {
//     if (window.__xnAddonCartHandlerInstalled) return;
//     window.__xnAddonCartHandlerInstalled = true;

//     const getPriceValue             = window.__xnPricing.getPriceValue;
//     const formatPriceLabel          = window.__xnPricing.formatPriceLabel;
//     const buildPersonalisationLabels = window.__xnPricing.buildPersonalisationLabels;

//     const XN_PREVIEW_IMAGES = {
//         none: [
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_1.png?v=1788298949',
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_2.png?v=1788298950'
//         ],
//         one: [
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_1.png?v=1788298949',
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949'
//         ],
//         two: [
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949',
//             'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949'
//         ]
//     };

//     function generateGroupId() {
//         return 'xn_grp_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
//     }

//     function getRoot() {
//         return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//             ? window.Shopify.routes.root : '/';
//     }

//     function getMainProductForm(target) {
//         const form = target.closest && target.closest('form[action*="/cart/add"]');
//         if (form) return form;
//         return document.querySelector('form[action*="/cart/add"]');
//     }

//     function getCartElement() {
//         return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
//     }

//     function getCartSectionIds(cartElement) {
//         if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
//             try {
//                 return cartElement.getSectionsToRender().map(s => s.id);
//             } catch (e) { /* fall through */ }
//         }
//         return ['cart-drawer', 'cart-icon-bubble'];
//     }

//     async function refreshCartIconBubble() {
//         try {
//             const res = await fetch(getRoot() + '?sections=cart-icon-bubble');
//             const sections = await res.json();
//             const bubbleWrapper = document.getElementById('cart-icon-bubble');
//             if (bubbleWrapper && sections['cart-icon-bubble']) {
//                 const dom = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
//                 const fresh = dom.getElementById('cart-icon-bubble');
//                 if (fresh) bubbleWrapper.innerHTML = fresh.innerHTML;
//             }
//         } catch (e) { /* non-critical */ }
//     }

//     function normalizeEngravingValue(value) {
//         return String(value || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n')
//             .split('\n').slice(0, 2)
//             .map(line => line.slice(0, 16))
//             .join('\n');
//     }

//     function getEngravingCountText(value) {
//         const lines = normalizeEngravingValue(value).split('\n');
//         const l1 = lines[0] ? lines[0].length : 0;
//         const l2 = lines[1] ? lines[1].length : 0;
//         return lines.length > 1 ? l1 + '/16 · ' + l2 + '/16' : l1 + ' / 16';
//     }

//     function resetAutoFitText(textEl) {
//         if (!textEl) return;
//         textEl.style.fontSize   = '';
//         textEl.style.lineHeight = '';
//     }

//     function autoFitMetalTagText(textEl) {
//         if (!textEl) return;
//         const tag = textEl.closest('.xn-addon-box__metal-tag');
//         if (!tag) return;
//         resetAutoFitText(textEl);
//         const text            = textEl.textContent || '';
//         const isPlaceholder   = textEl.classList.contains('is-placeholder');
//         const lines           = text.split('\n');
//         const hasTwoLines     = lines.length > 1;
//         const longestLen      = lines.reduce((max, l) => Math.max(max, l.length), 0);
//         let fontSize          = isPlaceholder ? 8 : 34;
//         const minFontSize     = isPlaceholder ? 6 : 7;
//         if (hasTwoLines) fontSize = isPlaceholder ? 8 : 33;
//         if (!isPlaceholder && longestLen > 10) {
//             fontSize = hasTwoLines ? Math.floor(fontSize * 0.82) : Math.floor(fontSize * 0.7);
//         }
//         textEl.style.fontSize   = fontSize + 'px';
//         textEl.style.lineHeight = hasTwoLines ? '1.18' : '1';
//         let guard = 0;
//         while (
//             guard < 100 && fontSize > minFontSize &&
//             (textEl.scrollWidth > textEl.clientWidth || textEl.scrollHeight > tag.clientHeight * 0.72)
//         ) { fontSize -= 1; textEl.style.fontSize = fontSize + 'px'; guard++; }
//     }

//     function autoFitAllMetalTagTexts() {
//         document.querySelectorAll('.xn-addon-box__metal-tag-text[data-xn-autofit]')
//             .forEach(autoFitMetalTagText);
//     }

//     function createMetalTagPreview(options) {
//         const { label = '', text = '', isPlaceholder = false, bgImage = '', showText = false } = options;
//         const wrap = document.createElement('div');
//         wrap.className    = 'xn-addon-box__metal-tag-wrap';
//         wrap.style.flex   = '1 1 0';
//         wrap.style.minWidth = '0';
//         if (label) {
//             const labelEl       = document.createElement('p');
//             labelEl.className   = 'xn-addon-box__metal-tag-label';
//             labelEl.textContent = label;
//             wrap.appendChild(labelEl);
//         }
//         const tag = document.createElement('div');
//         tag.className = 'xn-addon-box__metal-tag';
//         if (bgImage) {
//             tag.style.backgroundImage    = 'url(' + bgImage + ')';
//             tag.style.backgroundSize     = 'cover';
//             tag.style.backgroundPosition = 'center';
//             tag.style.backgroundRepeat   = 'no-repeat';
//         }
//         if (showText) {
//             const textEl = document.createElement('p');
//             textEl.className = 'xn-addon-box__metal-tag-text';
//             textEl.setAttribute('data-xn-autofit', 'true');
//             if (isPlaceholder) textEl.classList.add('is-placeholder');
//             textEl.textContent = text;
//             tag.appendChild(textEl);
//             window.requestAnimationFrame(() => autoFitMetalTagText(textEl));
//         }
//         wrap.appendChild(tag);
//         return wrap;
//     }

//     function parseVariantId(value) {
//         const id = Number(value);
//         return (!value || Number.isNaN(id) || id <= 0) ? null : id;
//     }

//     function getSelectedPersonalisation() {
//         const box = document.getElementById('personalisationBox');
//         if (!box) return null;
//         const selected = box.querySelector('input[name="personalisation_option"]:checked');
//         if (!selected) return null;
//         const mode = selected.dataset.mode || 'none';
//         if (mode === 'none') return null;
//         const selectedVariantId = parseVariantId(selected.value);
//         if (!selectedVariantId) {
//             box.classList.add('has-error');
//             throw new Error('The selected personalisation option is not available. Please refresh the page or choose another option.');
//         }
//         const sideOneInput = document.getElementById('personalisationSideOneInput');
//         const sideTwoInput = document.getElementById('personalisationSideTwoInput');
//         const sideOneValue = sideOneInput ? normalizeEngravingValue(sideOneInput.value).trim() : '';
//         const sideTwoValue = sideTwoInput ? normalizeEngravingValue(sideTwoInput.value).trim() : '';
//         if (mode === 'one' && !sideOneValue) {
//             box.classList.add('has-error');
//             if (sideOneInput) sideOneInput.focus();
//             throw new Error('Please enter the engraving text.');
//         }
//         if (mode === 'two' && (!sideOneValue || !sideTwoValue)) {
//             box.classList.add('has-error');
//             if (!sideOneValue && sideOneInput) sideOneInput.focus();
//             else if (sideTwoInput) sideTwoInput.focus();
//             throw new Error('Please enter the engraving text for both sides.');
//         }
//         return {
//             id:          selectedVariantId,
//             title:       selected.dataset.title || 'Personalisation',
//             price:       getPriceValue(selected.dataset.price),
//             mode:        mode,
//             sideOneText: sideOneValue,
//             sideTwoText: sideTwoValue
//         };
//     }

//     function getSelectedGift() {
//         const box = document.getElementById('giftReadyBox');
//         if (!box) return null;
//         const selected = box.querySelector('input[name="gift_packaging_option"]:checked');
//         if (!selected) return null;
//         const selectedVariantId = parseVariantId(selected.value);
//         if (!selectedVariantId) {
//             box.classList.add('has-error');
//             throw new Error('The selected gift packaging option is not available. Please refresh the page or choose another option.');
//         }
//         return {
//             id:    selectedVariantId,
//             title: selected.dataset.title || 'Gift Packaging',
//             price: getPriceValue(selected.dataset.price)
//         };
//     }

//     function renderPersonalisationPreview(preview, mode, sideOneValue, sideTwoValue) {
//         preview.innerHTML = '';
//         preview.style.cssText = 'display:flex;flex-direction:row;flex-wrap:nowrap;align-items:flex-start;justify-content:center;';
//         if (mode === 'two') {
//             preview.appendChild(createMetalTagPreview({ label: 'Side 1', text: sideOneValue || 'Side 1 engraving', isPlaceholder: !sideOneValue, bgImage: XN_PREVIEW_IMAGES.two[0], showText: true }));
//             preview.appendChild(createMetalTagPreview({ label: 'Side 2', text: sideTwoValue || 'Side 2 engraving', isPlaceholder: !sideTwoValue, bgImage: XN_PREVIEW_IMAGES.two[1], showText: true }));
//         } else if (mode === 'one') {
//             preview.appendChild(createMetalTagPreview({ label: 'Original side', bgImage: XN_PREVIEW_IMAGES.one[0], showText: false }));
//             preview.appendChild(createMetalTagPreview({ label: 'Your engraving', text: sideOneValue || 'Side 1 engraving', isPlaceholder: !sideOneValue, bgImage: XN_PREVIEW_IMAGES.one[1], showText: true }));
//         } else {
//             preview.appendChild(createMetalTagPreview({ bgImage: XN_PREVIEW_IMAGES.none[0], showText: false }));
//             preview.appendChild(createMetalTagPreview({ bgImage: XN_PREVIEW_IMAGES.none[1], showText: false }));
//         }
//         window.requestAnimationFrame(autoFitAllMetalTagTexts);
//     }

//     function updatePersonalisationUi() {
//         const box = document.getElementById('personalisationBox');
//         if (!box) return;
//         const selected      = box.querySelector('input[name="personalisation_option"]:checked');
//         const mode          = selected ? (selected.dataset.mode || 'none') : 'none';
//         const sideOneInput  = document.getElementById('personalisationSideOneInput');
//         const sideTwoInput  = document.getElementById('personalisationSideTwoInput');
//         const sideOneCount  = document.getElementById('personalisationSideOneCount');
//         const sideTwoCount  = document.getElementById('personalisationSideTwoCount');
//         const sideOneField  = document.getElementById('personalisationSideOneField');
//         const sideTwoField  = document.getElementById('personalisationSideTwoField');
//         const preview       = document.getElementById('personalisationPreview');
//         if (sideOneInput) {
//             const n = normalizeEngravingValue(sideOneInput.value);
//             if (sideOneInput.value !== n) sideOneInput.value = n;
//         }
//         if (sideTwoInput) {
//             const n = normalizeEngravingValue(sideTwoInput.value);
//             if (sideTwoInput.value !== n) sideTwoInput.value = n;
//         }
//         const sideOneValue = sideOneInput ? sideOneInput.value.trim() : '';
//         const sideTwoValue = sideTwoInput ? sideTwoInput.value.trim() : '';
//         box.classList.toggle('has-engraving',      mode === 'one' || mode === 'two');
//         box.classList.toggle('is-default-selected', mode === 'none');
//         box.classList.remove('has-error');
//         box.querySelectorAll('.xn-choice-card').forEach(card => {
//             const radio = card.querySelector('input[name="personalisation_option"]');
//             card.classList.toggle('is-selected', !!(radio && radio.checked));
//         });
//         if (sideOneField) sideOneField.style.display = (mode === 'one' || mode === 'two') ? 'block' : 'none';
//         if (sideTwoField) sideTwoField.style.display = mode === 'two' ? 'block' : 'none';
//         if (sideOneCount) sideOneCount.textContent = getEngravingCountText(sideOneInput ? sideOneInput.value : '');
//         if (sideTwoCount) sideTwoCount.textContent = getEngravingCountText(sideTwoInput ? sideTwoInput.value : '');
//         if (preview) renderPersonalisationPreview(preview, mode, sideOneValue, sideTwoValue);
//     }

//     function updateGiftUi() {
//         const box = document.getElementById('giftReadyBox');
//         if (!box) return;
//         box.classList.remove('has-error');
//         const selected = box.querySelector('input[name="gift_packaging_option"]:checked');
//         box.classList.toggle('is-default-selected', !!(selected && selected.dataset.default === 'true'));
//         box.querySelectorAll('.xn-gift-card').forEach(card => {
//             const radio = card.querySelector('input[name="gift_packaging_option"]');
//             card.classList.toggle('is-selected', !!(radio && radio.checked));
//         });
//     }

//     function initAddonUi() {
//         const box     = document.getElementById('personalisationBox');
//         const giftBox = document.getElementById('giftReadyBox');
//         if (box) {
//             box.querySelectorAll('input[name="personalisation_option"]').forEach(radio => {
//                 if (!radio.dataset.xnBound) {
//                     radio.dataset.xnBound = 'true';
//                     radio.addEventListener('change', updatePersonalisationUi);
//                 }
//             });
//         }
//         ['personalisationSideOneInput', 'personalisationSideTwoInput'].forEach(id => {
//             const input = document.getElementById(id);
//             if (input && !input.dataset.xnBound) {
//                 input.dataset.xnBound = 'true';
//                 input.addEventListener('input', updatePersonalisationUi);
//             }
//         });
//         if (giftBox) {
//             giftBox.querySelectorAll('input[name="gift_packaging_option"]').forEach(radio => {
//                 if (!radio.dataset.xnBound) {
//                     radio.dataset.xnBound = 'true';
//                     radio.addEventListener('change', updateGiftUi);
//                 }
//             });
//         }
//         updatePersonalisationUi();
//         updateGiftUi();
//         autoFitAllMetalTagTexts();
//     }
//     document.addEventListener('DOMContentLoaded', initAddonUi);
//     initAddonUi();
//     window.addEventListener('resize', () => window.requestAnimationFrame(autoFitAllMetalTagTexts));

//     document.addEventListener('submit', async function(event) {
//         const productForm = getMainProductForm(event.target);
//         if (!productForm || event.target !== productForm) return;
//         let selectedPersonalisation = null;
//         let selectedGift = null;
//         try {
//             selectedPersonalisation = getSelectedPersonalisation();
//             selectedGift            = getSelectedGift();
//         } catch (validationError) {
//             event.preventDefault();
//             event.stopImmediatePropagation();
//             if (validationError && validationError.message) alert(validationError.message);
//             return;
//         }
//         if (!selectedPersonalisation && !selectedGift) return;
//         event.preventDefault();
//         event.stopImmediatePropagation();
//         if (productForm.dataset.addonsSubmitting === 'true') return;
//         productForm.dataset.addonsSubmitting = 'true';
//         try {
//             const formData      = new FormData(productForm);
//             const mainVariantId = parseVariantId(formData.get('id'));
//             const quantity      = parseInt(formData.get('quantity') || '1', 10);
//             if (!mainVariantId) throw new Error('Missing main product variant.');

//             const groupId = generateGroupId();

//             const mainProperties = {};
//             if (selectedPersonalisation) {
//                 Object.assign(mainProperties, buildPersonalisationLabels({
//                     title:       selectedPersonalisation.title,
//                     mode:        selectedPersonalisation.mode,
//                     unitPrice:   selectedPersonalisation.price,
//                     quantity:    quantity,
//                     sideOneText: selectedPersonalisation.sideOneText,
//                     sideTwoText: selectedPersonalisation.sideTwoText
//                 }));
//                 mainProperties['_xn_personalisation_unit_price'] = String(selectedPersonalisation.price);
//                 mainProperties['_xn_personalisation_title']      = selectedPersonalisation.title;
//                 mainProperties['_xn_personalisation_mode']       = selectedPersonalisation.mode;
//                 mainProperties['_xn_side_one_text']              = selectedPersonalisation.sideOneText || '';
//                 mainProperties['_xn_side_two_text']              = selectedPersonalisation.sideTwoText || '';
//             }
//             if (selectedGift) {
//                 mainProperties['Gift Packaging']    = selectedGift.title + formatPriceLabel(selectedGift.price * quantity);
//                 mainProperties['_xn_gift_unit_price'] = String(selectedGift.price);
//                 mainProperties['_xn_gift_title']      = selectedGift.title;
//             }
//             mainProperties['_xn_group_id'] = groupId;

//             const items = [{ id: mainVariantId, quantity, properties: mainProperties }];
//             if (selectedPersonalisation) {
//                 items.push({
//                     id:         selectedPersonalisation.id,
//                     quantity,
//                     properties: {
//                         '_Add-on for variant':     String(mainVariantId),
//                         '_Add-on type':            'Personalisation',
//                         '_Personalisation option': selectedPersonalisation.title,
//                         '_Side 1 Text':            selectedPersonalisation.sideOneText || '',
//                         '_Side 2 Text':            selectedPersonalisation.sideTwoText || '',
//                         '_xn_group_id':            groupId
//                     }
//                 });
//             }
//             if (selectedGift) {
//                 items.push({
//                     id:         selectedGift.id,
//                     quantity,
//                     properties: {
//                         '_Add-on for variant': String(mainVariantId),
//                         '_Add-on type':        'Gift Packaging',
//                         '_Gift packaging':     selectedGift.title,
//                         '_xn_group_id':        groupId
//                     }
//                 });
//             }
//             const cartElement   = getCartElement();
//             const requestBody   = {
//                 items,
//                 sections:      getCartSectionIds(cartElement),
//                 sections_url:  window.location.pathname
//             };
//             if (cartElement && typeof cartElement.setActiveElement === 'function') {
//                 cartElement.setActiveElement(document.activeElement);
//             }
//             const response = await fetch(getRoot() + 'cart/add.js', {
//                 method:  'POST',
//                 headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//                 body:    JSON.stringify(requestBody)
//             });
//             if (!response.ok) {
//                 const errorData = await response.json().catch(() => ({}));
//                 throw new Error(errorData.description || 'Could not add selected options to cart.');
//             }
//             const responseJson = await response.json();
//             if (cartElement && typeof cartElement.renderContents === 'function') {
//                 if (cartElement.classList.contains('is-empty')) cartElement.classList.remove('is-empty');
//                 cartElement.renderContents(responseJson);
//                 if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//                     publish(PUB_SUB_EVENTS.cartUpdate, {
//                         source:            'product-form',
//                         productVariantId:  mainVariantId,
//                         cartData:          responseJson
//                     });
//                 }
//             } else {
//                 await refreshCartIconBubble();
//                 window.location.href = getRoot() + 'cart';
//             }
//         } catch (error) {
//             console.error('XN add-ons error:', error);
//             alert(error.message || 'Something went wrong while adding the selected options.');
//         } finally {
//             productForm.dataset.addonsSubmitting = 'false';
//         }
//     }, true);

//     function moveCartAddonsToBottom() {
//         const tbody = document.querySelector('#main-cart-items table.cart-items tbody');
//         if (!tbody) return;
//         const rows      = Array.from(tbody.querySelectorAll('tr.cart-item'));
//         const normalRows = rows.filter(r => !r.classList.contains('xn-cart-addon-item'));
//         const addonRows  = rows.filter(r =>  r.classList.contains('xn-cart-addon-item'));
//         if (!addonRows.length) return;
//         const desired = normalRows.concat(addonRows);
//         if (desired.every((r, i) => r === rows[i])) return;
//         desired.forEach(r => tbody.appendChild(r));
//     }
//     document.addEventListener('DOMContentLoaded', moveCartAddonsToBottom);
//     moveCartAddonsToBottom();
//     window.__xnMoveCartAddonsToBottom = moveCartAddonsToBottom; // reused by the qty/currency-sync module
//     const mainCartItemsContainer = document.getElementById('main-cart-items');
//     if (mainCartItemsContainer) {
//         new MutationObserver(() => window.requestAnimationFrame(moveCartAddonsToBottom))
//             .observe(mainCartItemsContainer, { childList: true, subtree: true });
//     }
// })();


// // ---------------------------------------------------------------------
// // Qty-sync + CURRENCY-sync — v17
// //
// // Keeps hidden add-on lines (Engraving Add-on / Gift Packaging Add-on)
// // in step with their main product, and rewrites price-label properties
// // whenever quantity, the active storefront currency, OR the set of
// // items in the cart changes (including removals).
// //
// // v15 fix (kept): syncs are QUEUED, never dropped — if a cart-change
// // event arrives while a sync is already running (e.g. two keyrings
// // removed back-to-back), another pass is scheduled instead of the
// // cleanup being silently discarded. Add-on cleanup (removals, quantity
// // matching) is batched into a single /cart/update.js call, keyed by
// // each line's stable `key` (not position), so there's no reindexing to
// // manage.
// //
// // v16 (kept):
// //   - PERCEIVED SPEED: the instant a removal is detected, orphaned
// //     add-on rows fade out and collapse — before the network confirms
// //     anything. The on-page total dims while a sync is in flight.
// //   - REAL SPEED: price-label rewrites for several main items fire in
// //     parallel, followed by a single consolidating fetch.
// //
// // v17 — CART DRAWER speed fixes (this version):
// //   - NO MORE DOUBLE RENDER. Every sync published cartUpdate with a
// //     custom source. Dawn's cart-drawer-items answers any source other
// //     than 'cart-items' by fetching ?section_id=cart-drawer and
// //     replacing the drawer AGAIN — a redundant round trip and a second
// //     repaint right after ours. When the drawer has been rendered in
// //     place, the event is now published as source 'cart-items' (Dawn's
// //     own "the cart UI is already rendered" tag) so that refetch is
// //     skipped. Our own subscriber keys off `xnSource` instead.
// //   - NO MORE open() ON EVERY PASS. The drawer was re-rendered through
// //     cart-drawer.renderContents(), which re-runs open() each time:
// //     restarts the slide-in animation, re-arms focus trapping and, on
// //     the on-load currency pass, popped the drawer open on page load.
// //     The drawer's sections are now swapped in place (same DOM result).
// //   - ONE LESS REQUEST per label rewrite. A single price-label rewrite
// //     no longer does a follow-up no-op cart/update.js just to refetch:
// //     the change.js response already carries the consistent cart and
// //     rendered sections. One-item carts (the common case) save a round
// //     trip on every quantity change.
// //   - OWN EVENTS IGNORED PROPERLY. The subscriber only filtered
// //     'xn-qty-sync', so our 'xn-currency-sync-onload' and
// //     'xn-cartpage-qty-fallback' publishes triggered a redundant extra
// //     sync pass.
// // ---------------------------------------------------------------------
// (function() {
//     if (window.__xnQtySyncInstalled) return;
//     window.__xnQtySyncInstalled = true;

//     const formatPriceLabel           = window.__xnPricing.formatPriceLabel;
//     const buildPersonalisationLabels = window.__xnPricing.buildPersonalisationLabels;

//     function getRoot() {
//         return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//             ? window.Shopify.routes.root : '/';
//     }
//     function getCartElement() {
//         return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
//     }

//     // v16: lightweight CSS for the optimistic fade + the "syncing"
//     // dimming on the total, injected once.
//     function injectXnSyncStyles() {
//         if (document.getElementById('xn-sync-styles')) return;
//         const style = document.createElement('style');
//         style.id = 'xn-sync-styles';
//         style.textContent =
//             '.xn-row-removing{opacity:0!important;max-height:0!important;overflow:hidden!important;' +
//             'padding-top:0!important;padding-bottom:0!important;margin-top:0!important;margin-bottom:0!important;' +
//             'transition:opacity .18s ease,max-height .22s ease,padding .22s ease,margin .22s ease;pointer-events:none;}' +
//             '.xn-total-syncing{opacity:.45;transition:opacity .15s ease;}';
//         document.head.appendChild(style);
//     }

//     // Best-effort selectors for the on-page estimated-total element(s).
//     // Adjust these to match your theme's markup if the dim effect
//     // doesn't appear — harmless no-op if nothing matches.
//     function getTotalElements() {
//         return Array.from(document.querySelectorAll(
//             '.totals__total-value, .cart__footer .totals__total-value, ' +
//             '.drawer__footer .totals__total-value, [data-cart-total], .cart-total, .cart__total'
//         ));
//     }
//     function setTotalSyncing(active) {
//         getTotalElements().forEach(el => el.classList.toggle('xn-total-syncing', active));
//     }

//     // Row containers that render cart line items in cart.items order —
//     // the standalone cart page (confirmed markup) and, best-effort, the
//     // cart drawer / notification if your theme reuses the same row
//     // structure there.
//     function getCartItemRowContainers() {
//         return Array.from(document.querySelectorAll(
//             '#main-cart-items table.cart-items tbody, cart-drawer .cart-items, cart-notification .cart-items'
//         ));
//     }

//     // v16: the moment we see a cart state where an add-on's main item is
//     // gone, fade that row out right away — don't wait for the network
//     // round trip that actually removes it. Purely visual; the real sync
//     // below still runs and is the source of truth.
//     function markOrphanAddonRowsAsRemoving(cartData) {
//         if (!cartData || !Array.isArray(cartData.items)) return;
//         getCartItemRowContainers().forEach(container => {
//             const rows = Array.from(container.querySelectorAll('tr.cart-item, .cart-item'));
//             cartData.items.forEach((item, idx) => {
//                 if (!isAddonItem(item)) return;
//                 if (findMainItem(cartData.items, item)) return; // not an orphan
//                 const row = rows[idx];
//                 if (row) row.classList.add('xn-row-removing');
//             });
//         });
//     }

//     async function postCartChange(payload, sectionIds) {
//         const res = await fetch(getRoot() + 'cart/change.js', {
//             method:  'POST',
//             headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//             body:    JSON.stringify(Object.assign({}, payload, { sections: sectionIds, sections_url: window.location.pathname }))
//         });
//         const data = await res.json();
//         if (!res.ok) throw new Error((data && data.description) || 'cart/change.js request failed');
//         return data;
//     }

//     // Batched multi-line quantity update, keyed by line `key`. Also used
//     // with an EMPTY updates object as a cheap way to re-fetch a fully
//     // consistent cart (with rendered sections) after parallel writes.
//     async function postCartUpdateBatch(updatesByKey, sectionIds) {
//         const res = await fetch(getRoot() + 'cart/update.js', {
//             method:  'POST',
//             headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//             body:    JSON.stringify({ updates: updatesByKey, sections: sectionIds, sections_url: window.location.pathname })
//         });
//         const data = await res.json();
//         if (!res.ok) throw new Error((data && data.description) || 'cart/update.js request failed');
//         return data;
//     }

//     async function fetchCart() {
//         const res  = await fetch(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
//         const data = await res.json();
//         if (!res.ok) throw new Error('cart.js request failed');
//         return data;
//     }

//     function getSectionIdForElement(el) {
//         if (!el) return null;
//         if (el.dataset && el.dataset.id) return el.dataset.id;
//         const wrapper = el.closest('[id^="shopify-section-"]');
//         if (wrapper) return wrapper.id.replace('shopify-section-', '');
//         return null;
//     }
//     function getMainCartItemsSectionId() {
//         return getSectionIdForElement(document.getElementById('main-cart-items'));
//     }
//     function getCartSectionIds(cartElement) {
//         let ids = [];
//         if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
//             try {
//                 ids = cartElement.getSectionsToRender().map(s => s.id).filter(Boolean);
//             } catch (e) { /* fall through */ }
//         }
//         if (!ids.length) ids = ['cart-drawer', 'cart-icon-bubble'];
//         const mainCartSectionId = getMainCartItemsSectionId();
//         if (mainCartSectionId && ids.indexOf(mainCartSectionId) === -1) ids.push(mainCartSectionId);
//         return ids;
//     }

//     // v17: render the cart drawer's sections IN PLACE — exactly what
//     // Dawn's cart-drawer.renderContents() does to the DOM, minus the
//     // open() call (which restarts the slide-in animation, re-arms focus
//     // trapping, and pops the drawer open during the on-load sync).
//     // Returns true if at least one section was swapped.
//     function renderDrawerSectionsInPlace(cartElement, cartResponse) {
//         let sections = [];
//         try { sections = cartElement.getSectionsToRender() || []; } catch (e) { sections = []; }
//         if (!sections.length || !cartResponse.sections) return false;
//         let rendered = false;
//         sections.forEach(section => {
//             const html = cartResponse.sections[section.id];
//             if (!html) return;
//             const target = section.selector
//                 ? document.querySelector(section.selector)
//                 : document.getElementById(section.id);
//             if (!target) return;
//             const doc    = new DOMParser().parseFromString(html, 'text/html');
//             const source = section.selector
//                 ? doc.querySelector(section.selector)
//                 : doc.querySelector('.shopify-section');
//             if (!source) return;
//             target.innerHTML = source.innerHTML;
//             rendered = true;
//         });
//         if (rendered) {
//             // Dawn binds "click overlay to close" inside renderContents();
//             // since we bypass it, re-bind on the freshly rendered overlay.
//             const overlay = cartElement.querySelector('#CartDrawer-Overlay');
//             if (overlay && typeof cartElement.close === 'function' && !overlay.dataset.xnCloseBound) {
//                 overlay.dataset.xnCloseBound = 'true';
//                 overlay.addEventListener('click', cartElement.close.bind(cartElement));
//             }
//         }
//         return rendered;
//     }

//     // Returns true when the cart drawer was rendered in place (used to
//     // decide how the cartUpdate event is published — see runSyncOnce).
//     function renderCartSections(cartElement, cartResponse) {
//         if (!cartResponse) return false;
//         let drawerRenderedInPlace = false;
//         if (cartElement && typeof cartResponse.item_count !== 'undefined') {
//             if (cartElement.tagName === 'CART-DRAWER') {
//                 drawerRenderedInPlace = renderDrawerSectionsInPlace(cartElement, cartResponse);
//             }
//             if (drawerRenderedInPlace) {
//                 cartElement.classList.toggle('is-empty', cartResponse.item_count === 0);
//             } else if (typeof cartElement.renderContents === 'function') {
//                 // cart-notification, or a drawer whose sections didn't come
//                 // back — fall back to the theme's own renderer.
//                 cartElement.classList.toggle('is-empty', cartResponse.item_count === 0);
//                 cartElement.renderContents(cartResponse);
//             }
//         }
//         const mainCartItemsEl   = document.getElementById('main-cart-items');
//         const mainCartSectionId = getMainCartItemsSectionId();
//         if (mainCartItemsEl && mainCartSectionId && cartResponse.sections && cartResponse.sections[mainCartSectionId]) {
//             const parsedDoc = new DOMParser().parseFromString(cartResponse.sections[mainCartSectionId], 'text/html');
//             const freshEl   = parsedDoc.getElementById('main-cart-items');
//             if (freshEl) {
//                 mainCartItemsEl.innerHTML = freshEl.innerHTML;
//                 window.requestAnimationFrame(() => {
//                     if (typeof window.__xnMoveCartAddonsToBottom === 'function') window.__xnMoveCartAddonsToBottom();
//                 });
//             }
//         }
//         return drawerRenderedInPlace;
//     }

//     function isAddonItem(item) {
//         return !!(item.properties && (item.properties['_Add-on type'] || item.properties['_Add-on for variant']));
//     }

//     function findMainItem(items, addonItem) {
//         const props = (addonItem && addonItem.properties) || {};
//         const groupId = props['_xn_group_id'];
//         if (groupId) {
//             return items.find(mi =>
//                 !isAddonItem(mi) &&
//                 mi.properties &&
//                 mi.properties['_xn_group_id'] === groupId
//             );
//         }
//         const linkedVariantId = props['_Add-on for variant'];
//         return items.find(mi => String(mi.variant_id) === String(linkedVariantId) && !isAddonItem(mi));
//     }

//     function findAddonItemsForMain(items, mainItem) {
//         const groupId = mainItem.properties && mainItem.properties['_xn_group_id'];
//         if (groupId) {
//             return items.filter(it => isAddonItem(it) && it.properties && it.properties['_xn_group_id'] === groupId);
//         }
//         return items.filter(it =>
//             isAddonItem(it) &&
//             it.properties &&
//             String(it.properties['_Add-on for variant']) === String(mainItem.variant_id)
//         );
//     }

//     function getLiveUnitPrice(addonItem) {
//         if (!addonItem) return 0;
//         if (typeof addonItem.final_price === 'number') {
//             return addonItem.final_price / 100;
//         }
//         if (addonItem.final_line_price && addonItem.quantity) {
//             return (addonItem.final_line_price / addonItem.quantity) / 100;
//         }
//         return 0;
//     }

//     function getUpdatedPropertiesIfNeeded(item, addonItems) {
//         const rawProps = item.properties || {};
//         const props    = {};
//         Object.keys(rawProps).forEach(k => {
//             if (rawProps[k] !== null && rawProps[k] !== undefined) props[k] = rawProps[k];
//         });
//         let changed  = false;
//         const qty    = item.quantity;

//         const personalisationAddon = addonItems.find(a => a.properties && a.properties['_Add-on type'] === 'Personalisation');
//         const giftAddon             = addonItems.find(a => a.properties && a.properties['_Add-on type'] === 'Gift Packaging');

//         if (props['_xn_personalisation_unit_price'] !== undefined) {
//             const liveTotal      = personalisationAddon ? (personalisationAddon.final_line_price / 100) : null;
//             const liveUnitPrice  = personalisationAddon ? getLiveUnitPrice(personalisationAddon) : (parseFloat(props['_xn_personalisation_unit_price']) || 0);
//             const title    = props['_xn_personalisation_title'] || '';
//             const expected = props['_xn_personalisation_mode']
//                 ? buildPersonalisationLabels({
//                     title,
//                     mode:        props['_xn_personalisation_mode'],
//                     total:       liveTotal !== null ? liveTotal : (liveUnitPrice * qty),
//                     sideOneText: props['_xn_side_one_text'] || '',
//                     sideTwoText: props['_xn_side_two_text'] || ''
//                 })
//                 : { 'Personalisation Option': title + formatPriceLabel(liveTotal !== null ? liveTotal : (liveUnitPrice * qty)) };
//             Object.keys(expected).forEach(k => {
//                 if (props[k] !== expected[k]) { props[k] = expected[k]; changed = true; }
//             });
//             const liveUnitPriceStr = String(liveUnitPrice);
//             if (props['_xn_personalisation_unit_price'] !== liveUnitPriceStr) {
//                 props['_xn_personalisation_unit_price'] = liveUnitPriceStr;
//                 changed = true;
//             }
//         }

//         if (props['_xn_gift_unit_price'] !== undefined) {
//             const liveTotal     = giftAddon ? (giftAddon.final_line_price / 100) : null;
//             const liveUnitPrice = giftAddon ? getLiveUnitPrice(giftAddon) : (parseFloat(props['_xn_gift_unit_price']) || 0);
//             const title    = props['_xn_gift_title'] || '';
//             const expected = title + formatPriceLabel(liveTotal !== null ? liveTotal : (liveUnitPrice * qty));
//             if (props['Gift Packaging'] !== expected) { props['Gift Packaging'] = expected; changed = true; }
//             const liveUnitPriceStr = String(liveUnitPrice);
//             if (props['_xn_gift_unit_price'] !== liveUnitPriceStr) {
//                 props['_xn_gift_unit_price'] = liveUnitPriceStr;
//                 changed = true;
//             }
//         }
//         return changed ? props : null;
//     }

//     // One sync pass.
//     //   Phase 1 — batch-fix add-on quantities/removals (one call).
//     //   Phase 2 — price-label rewrites. ONE main item needing a rewrite
//     //             (the common case) is a single change.js call whose
//     //             response is used directly. SEVERAL fire in parallel,
//     //             followed by one cheap "empty update" to pull back a
//     //             consistent cart (with sections).
//     async function runSyncOnce(cartData, sourceTag) {
//         if (!cartData || !Array.isArray(cartData.items)) return null;
//         const cartElement = getCartElement();
//         const sectionIds  = getCartSectionIds(cartElement);
//         let currentCart = cartData;
//         let didAnything = false;

//         // Phase 1
//         const updates = {};
//         currentCart.items.forEach(function(item) {
//             if (!isAddonItem(item)) return;
//             const mainItem  = findMainItem(currentCart.items, item);
//             const targetQty = mainItem ? mainItem.quantity : 0;
//             if (targetQty !== item.quantity) {
//                 updates[item.key] = targetQty;
//             }
//         });
//         if (Object.keys(updates).length) {
//             currentCart = await postCartUpdateBatch(updates, sectionIds);
//             didAnything = true;
//         }

//         // Phase 2 — compute every needed label update from one consistent
//         // snapshot.
//         const propUpdates = [];
//         for (const item of currentCart.items) {
//             if (isAddonItem(item)) continue;
//             const linkedAddons = findAddonItemsForMain(currentCart.items, item);
//             const updatedProps = getUpdatedPropertiesIfNeeded(item, linkedAddons);
//             if (updatedProps) propUpdates.push({ key: item.key, quantity: item.quantity, properties: updatedProps });
//         }
//         if (propUpdates.length === 1) {
//             // v17: the single change.js response already IS the consistent
//             // cart with rendered sections — no follow-up fetch needed.
//             const u = propUpdates[0];
//             try {
//                 currentCart = await postCartChange({ id: u.key, quantity: u.quantity, properties: u.properties }, sectionIds);
//             } catch (e) {
//                 console.error('XN label rewrite failed, refetching cart:', e);
//                 currentCart = await postCartUpdateBatch({}, sectionIds);
//             }
//             didAnything = true;
//         } else if (propUpdates.length > 1) {
//             await Promise.allSettled(
//                 propUpdates.map(u => postCartChange({ id: u.key, quantity: u.quantity, properties: u.properties }, sectionIds))
//             );
//             // Parallel writes can each reflect a slightly different
//             // snapshot — pull a single consistent cart (with sections)
//             // back with one cheap no-op update call.
//             currentCart = await postCartUpdateBatch({}, sectionIds);
//             didAnything = true;
//         }

//         if (didAnything) {
//             const drawerRenderedInPlace = renderCartSections(cartElement, currentCart);
//             if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//                 // v17: when the drawer is already rendered, publish as
//                 // 'cart-items' so Dawn's cart-drawer-items doesn't refetch
//                 // and replace the drawer a second time. `xnSource` is how
//                 // our own subscriber recognises (and ignores) this event.
//                 publish(PUB_SUB_EVENTS.cartUpdate, {
//                     source:   drawerRenderedInPlace ? 'cart-items' : (sourceTag || 'xn-qty-sync'),
//                     xnSource: sourceTag || 'xn-qty-sync',
//                     cartData: currentCart
//                 });
//             }
//         }
//         return currentCart;
//     }

//     let xnSyncing          = false;
//     let xnResyncRequested  = false;

//     async function requestSync(cartData, sourceTag) {
//         // v16: instant visual feedback, before any network round trip.
//         injectXnSyncStyles();
//         markOrphanAddonRowsAsRemoving(cartData);
//         setTotalSyncing(true);

//         if (xnSyncing) {
//             xnResyncRequested = true;
//             return;
//         }
//         xnSyncing = true;
//         try {
//             await runSyncOnce(cartData, sourceTag);
//             while (xnResyncRequested) {
//                 xnResyncRequested = false;
//                 try {
//                     const latestCart = await fetchCart();
//                     markOrphanAddonRowsAsRemoving(latestCart);
//                     await runSyncOnce(latestCart, sourceTag);
//                 } catch (e) {
//                     console.error('XN qty/currency-sync (queued pass) error:', e);
//                 }
//             }
//         } catch (err) {
//             console.error('XN qty/currency-sync error:', err);
//         } finally {
//             xnSyncing = false;
//             setTotalSyncing(false);
//         }
//     }

//     // v17: recognise every event we published ourselves (any sourceTag),
//     // not just 'xn-qty-sync'.
//     function isOwnSyncEvent(event) {
//         if (!event) return false;
//         if (event.xnSource) return true;
//         return typeof event.source === 'string' && event.source.indexOf('xn-') === 0;
//     }

//     // React to normal AJAX cart changes (add/update/remove) as before.
//     if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//         subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
//             if (isOwnSyncEvent(event)) return;
//             const cartData = event && event.cartData;
//             if (!cartData) return;
//             requestSync(cartData, 'xn-qty-sync');
//         });
//     }

//     // Also run once on page load — a country/currency switch (Shopify
//     // Markets) is normally a full page reload, not a cartUpdate event.
//     async function syncOnLoad() {
//         try {
//             const cart = await fetchCart();
//             if (cart && Array.isArray(cart.items) && cart.items.length) {
//                 await requestSync(cart, 'xn-currency-sync-onload');
//             }
//         } catch (e) {
//             console.error('XN on-load currency-sync error:', e);
//         }
//     }
//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', syncOnLoad);
//     } else {
//         syncOnLoad();
//     }

//     // Fallback for the standalone /cart page, for themes that don't
//     // publish PUB_SUB_EVENTS.cartUpdate from the page's own quantity
//     // stepper or remove button.
//     // v16: debounce shortened further (400ms → 250ms) — safe since a
//     // sync firing a touch early can no longer lose work, and the
//     // optimistic fade already gives instant feedback regardless.
//     const XN_CART_PAGE_FALLBACK_DEBOUNCE_MS = 250;

//     function attachCartPageQuantityFallback() {
//         const container = document.getElementById('main-cart-items');
//         if (!container || container.dataset.xnQtyFallbackBound) return;
//         container.dataset.xnQtyFallbackBound = 'true';
//         let debounceTimer = null;
//         function scheduleResync() {
//             clearTimeout(debounceTimer);
//             debounceTimer = setTimeout(async () => {
//                 try {
//                     const cart = await fetchCart();
//                     await requestSync(cart, 'xn-cartpage-qty-fallback');
//                 } catch (e) {
//                     console.error('XN cart-page quantity fallback sync error:', e);
//                 }
//             }, XN_CART_PAGE_FALLBACK_DEBOUNCE_MS);
//         }
//         container.addEventListener('change', function(e) {
//             const t = e.target;
//             if (!t) return;
//             if (t.matches('input[type="number"], input[name="updates[]"], .quantity__input')) {
//                 scheduleResync();
//             }
//         });
//         container.addEventListener('click', function(e) {
//             if (e.target.closest('.quantity__button, [name="plus"], [name="minus"], cart-remove-button, .cart-remove-button')) {
//                 scheduleResync();
//             }
//         });
//     }
//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', attachCartPageQuantityFallback);
//     } else {
//         attachCartPageQuantityFallback();
//     }
// })();


// // ---------------------------------------------------------------------
// // Custom PDP price display
// // ---------------------------------------------------------------------
// $(document).ready(function () {
//     const getPrice      = window.__xnPricing.getPriceValue;
//     const formatAmount  = window.__xnPricing.formatAmount;

//     function getSelectedQuantity() {
//         const qty = parseInt($('form[action*="/cart/add"] input[name="quantity"]').first().val(), 10);
//         return (qty && qty > 0) ? qty : 1;
//     }

//     function updateTotalPrice() {
//         const $priceElement = $(
//             '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
//         );

//         // Base (main product) price. Normally read from the personalisation
//         // radios' pro-price. On the no-engraving template those radios aren't
//         // rendered, so fall back to the gift radios' pro-price (same value),
//         // then to the container's data-xn-base-price — so it never drops to 0.
//         let $baseOption = $('input[name="personalisation_option"]').first();
//         if (!$baseOption.length) $baseOption = $('input[name="gift_packaging_option"]').first();
//         let totalPrice = $baseOption.length ? getPrice($baseOption.attr('pro-price')) : 0;
//         if (!totalPrice) {
//             const baseAttr = $('.xn-make-yours').attr('data-xn-base-price');
//             if (baseAttr) totalPrice = getPrice(baseAttr);
//         }

//         const $selPersonalisation = $('input[name="personalisation_option"]:checked').first();
//         if ($selPersonalisation.length) {
//             totalPrice += getPrice($selPersonalisation.attr('data-price'));
//         }

//         $('input[name="gift_packaging_option"]:checked').each(function () {
//             totalPrice += getPrice($(this).attr('data-price'));
//         });

//         totalPrice *= getSelectedQuantity();

//         const wrap = window.__xnPricing.parseCurrencyWrapper();
//         const formatted = wrap.prefix + formatAmount(totalPrice) + (wrap.suffix ? ' ' + wrap.suffix : '');
//         $priceElement.text(formatted);
//     }

//     $('input[name="personalisation_option"]').on('change', updateTotalPrice);
//     $('input[name="gift_packaging_option"]').on('change',  updateTotalPrice);
//     $(document).on('change input', 'form[action*="/cart/add"] input[name="quantity"]', updateTotalPrice);
//     updateTotalPrice();
// });

// Custom script by XNEST
// "Make It Yours" — product personalisation, gift packaging and engraving preview
// Current version: v20 (cart page: add-ons now removed reliably when the product is deleted). Older commented-out versions removed.

// ---------------------------------------------------------------------
// v20: cart request hook.
// Detects when the THEME's own cart request (remove / quantity change / add)
// has finished, and tells the sync module to run. This replaces the old
// click-on-remove-button timer, which could fire before the theme's delete
// request had landed — the sync then saw the old cart and never removed the
// add-on lines. Our own requests use __xnOrigFetch and are never hooked.
// ---------------------------------------------------------------------
(function() {
    if (window.__xnFetchHookInstalled) return;
    window.__xnFetchHookInstalled = true;
    const origFetch = window.fetch;
    if (typeof origFetch !== 'function') return;
    window.__xnOrigFetch = origFetch.bind(window);
    const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;
    window.fetch = function(input) {
        const promise = origFetch.apply(window, arguments);
        try {
            const url = typeof input === 'string' ? input : ((input && (input.url || input.href)) || '');
            if (CART_MUTATION_RE.test(url)) {
                promise.then(function(res) {
                    if (res && res.ok && typeof window.__xnOnThemeCartRequest === 'function') {
                        window.__xnOnThemeCartRequest(url);
                    }
                }).catch(function() { /* ignore */ });
            }
        } catch (e) { /* never break the theme's fetch */ }
        return promise;
    };
})();

window.__xnPricing = window.__xnPricing || (function() {

    // v8: maps Shopify currency codes to a BCP-47 locale whose number-formatting
    // rules match how Shopify itself renders that currency on the storefront.
    var CURRENCY_LOCALE_MAP = {
        // Comma-decimal currencies
        'EUR': 'de-DE', 'PLN': 'pl-PL', 'SEK': 'sv-SE', 'NOK': 'nb-NO',
        'DKK': 'da-DK', 'HUF': 'hu-HU', 'CZK': 'cs-CZ', 'RON': 'ro-RO',
        'BGN': 'bg-BG', 'HRK': 'hr-HR', 'RUB': 'ru-RU', 'UAH': 'uk-UA',
        'BRL': 'pt-BR', 'ARS': 'es-AR', 'COP': 'es-CO', 'CLP': 'es-CL',
        'VND': 'vi-VN', 'IDR': 'id-ID', 'ISK': 'is-IS', 'TRY': 'tr-TR',
        // Dot-decimal currencies
        'USD': 'en-US', 'GBP': 'en-GB', 'AUD': 'en-AU', 'CAD': 'en-CA',
        'NZD': 'en-NZ', 'SGD': 'en-SG', 'HKD': 'en-HK', 'ZAR': 'en-ZA',
        'MXN': 'es-MX', 'CHF': 'de-CH', 'JPY': 'ja-JP', 'KRW': 'ko-KR',
        'INR': 'en-IN', 'PKR': 'en-PK', 'BDT': 'bn-BD', 'LKR': 'si-LK',
        'AED': 'ar-AE', 'SAR': 'ar-SA', 'QAR': 'ar-QA', 'KWD': 'ar-KW',
        'BHD': 'ar-BH', 'OMR': 'ar-OM', 'JOD': 'ar-JO', 'ILS': 'he-IL',
        'THB': 'th-TH', 'MYR': 'ms-MY', 'PHP': 'en-PH', 'TWD': 'zh-TW',
        'CNY': 'zh-CN', 'EGP': 'ar-EG', 'MAD': 'fr-MA', 'NGN': 'en-NG',
        'GHS': 'en-GH', 'KES': 'sw-KE', 'TZS': 'sw-TZ', 'UGX': 'sw-UG',
        'ETB': 'am-ET', 'CRC': 'es-CR', 'PEN': 'es-PE', 'UYU': 'es-UY',
        'BOB': 'es-BO', 'PYG': 'es-PY', 'DOP': 'es-DO', 'GTQ': 'es-GT',
        'HNL': 'es-HN', 'NIO': 'es-NI', 'PAB': 'es-PA', 'VEF': 'es-VE'
    };

    // v8: locale-aware price parser.
    function getPriceValue(value) {
        if (typeof value === 'number') return isFinite(value) ? value : 0;
        if (!value) return 0;
        var s = String(value).replace(/[^0-9.,-]/g, '');
        if (!s) return 0;
        var neg = s.charAt(0) === '-';
        s = s.replace(/-/g, '');
        var hasDot   = s.indexOf('.') !== -1;
        var hasComma = s.indexOf(',') !== -1;
        var decimalSep = '';
        if (hasDot && hasComma) {
            decimalSep = s.lastIndexOf(',') > s.lastIndexOf('.') ? ',' : '.';
        } else if (hasDot || hasComma) {
            var sep   = hasDot ? '.' : ',';
            var parts = s.split(sep);
            if (parts.length === 2 && parts[1].length > 0 && parts[1].length <= 2) {
                decimalSep = sep;
            }
        }
        if (decimalSep) {
            var thousandsSep = decimalSep === ',' ? '.' : ',';
            s = s.split(thousandsSep).join('').replace(decimalSep, '.');
        } else {
            s = s.replace(/[.,]/g, '');
        }
        var n = parseFloat(s);
        if (isNaN(n)) return 0;
        return neg ? -n : n;
    }

    function getPriceElMoneyString() {
        var priceEl = document.querySelector(
            '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
        ) || document.querySelector('.custom_product_price');
        return priceEl ? priceEl.getAttribute('data-original-money') || priceEl.textContent.trim() : '';
    }

    // v19: money sample printed by the cart page Liquid (hidden span).
    function getMoneySampleString() {
        var el = document.querySelector('.xn-money-sample');
        return el ? (el.getAttribute('data-money') || '') : '';
    }

    function splitMoneyString(s) {
        var prefixMatch = s.match(/^([^0-9]*)/);
        var suffixMatch = s.match(/([^0-9]*)$/);
        var prefix = prefixMatch ? prefixMatch[1] : '';
        var suffix = suffixMatch ? suffixMatch[1] : '';
        suffix = suffix.replace(/^[\s,.'-]+/, '');
        return { prefix: prefix, suffix: suffix };
    }

    function readCachedWrapper(code) {
        try {
            var raw = window.localStorage.getItem('xn_currency_wrapper_' + code);
            return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
    }

    function writeCachedWrapper(code, wrapper) {
        try {
            window.localStorage.setItem('xn_currency_wrapper_' + code, JSON.stringify(wrapper));
        } catch (e) { /* storage unavailable */ }
    }

    // Last-resort symbol/position from Intl for the active currency.
    function intlWrapper(code) {
        try {
            var locale = CURRENCY_LOCALE_MAP[code] || 'en-US';
            var parts  = new Intl.NumberFormat(locale, { style: 'currency', currency: code }).formatToParts(1);
            var prefix = '', suffix = '', seenNumber = false;
            parts.forEach(function(p) {
                if (p.type === 'currency') {
                    if (seenNumber) suffix = p.value; else prefix = p.value;
                } else if (p.type === 'integer' || p.type === 'decimal' || p.type === 'fraction' || p.type === 'group') {
                    seenNumber = true;
                }
            });
            return { prefix: prefix, suffix: suffix };
        } catch (e) { return null; }
    }

    // v19: BUGFIX for the cart page. The PDP price element doesn't exist
    // there, so this used to fall back to a hard-coded "₹" even for EUR/USD
    // customers, and label rewrites on the cart page used the wrong symbol.
    // Order: PDP element -> cart-page money sample -> cached wrapper for this
    // currency (saved from a previous PDP visit) -> Intl -> "₹".
    function parseCurrencyWrapper() {
        var code = getStorefrontCurrencyCode();
        var s = getPriceElMoneyString() || getMoneySampleString();
        if (s && /[0-9]/.test(s)) {
            var wrapper = splitMoneyString(s);
            writeCachedWrapper(code, wrapper);
            return wrapper;
        }
        return readCachedWrapper(code) || intlWrapper(code) || { prefix: '₹', suffix: '' };
    }

    function getStorefrontCurrencySymbol() {
        return parseCurrencyWrapper().prefix || '₹';
    }

    function getStorefrontCurrencyCode() {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
            return window.Shopify.currency.active;
        }
        var priceEl = document.querySelector(
            '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
        ) || document.querySelector('.custom_product_price');
        return (priceEl && priceEl.getAttribute('data-currency')) || 'INR';
    }

    function formatAmount(amount, decimalPlaces) {
        var dp = (decimalPlaces === undefined) ? 2 : decimalPlaces;
        var code   = getStorefrontCurrencyCode();
        var locale = CURRENCY_LOCALE_MAP[code] || 'en-US';
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits: dp,
            maximumFractionDigits: dp
        }).format(amount);
    }

    function formatPriceLabel(price) {
        if (!price || price <= 0) return '';
        var wrap   = parseCurrencyWrapper();
        var number = formatAmount(price);
        var formatted = wrap.prefix + number + (wrap.suffix ? ' ' + wrap.suffix : '');
        return ' (+' + formatted + ')';
    }

    function splitPriceInTwo(total) {
        var totalMinor = Math.round((total || 0) * 100);
        var first = Math.ceil(totalMinor / 2);
        return [first / 100, (totalMinor - first) / 100];
    }

    function buildPersonalisationLabels(opts) {
        var labels = { 'Personalisation Option': opts.title || 'Personalisation' };
        // v14: prefer an authoritative total (Shopify's own final_line_price for
        // the linked add-on line) over recomputing unitPrice*quantity.
        var total = (typeof opts.total === 'number') ? opts.total : (opts.unitPrice || 0) * (opts.quantity || 1);
        if (opts.mode === 'one') {
            labels['Side 1 Text'] = (opts.sideOneText || '') + formatPriceLabel(total);
        } else if (opts.mode === 'two') {
            var halves = splitPriceInTwo(total);
            labels['Side 1 Text'] = (opts.sideOneText || '') + formatPriceLabel(halves[0]);
            labels['Side 2 Text'] = (opts.sideTwoText || '') + formatPriceLabel(halves[1]);
        }
        return labels;
    }

    return {
        getPriceValue:               getPriceValue,
        getStorefrontCurrencySymbol: getStorefrontCurrencySymbol,
        getStorefrontCurrencyCode:   getStorefrontCurrencyCode,
        parseCurrencyWrapper:        parseCurrencyWrapper,
        formatAmount:                formatAmount,
        formatPriceLabel:            formatPriceLabel,
        splitPriceInTwo:             splitPriceInTwo,
        buildPersonalisationLabels:  buildPersonalisationLabels
    };
})();

(function() {
    if (window.__xnAddonCartHandlerInstalled) return;
    window.__xnAddonCartHandlerInstalled = true;

    const getPriceValue              = window.__xnPricing.getPriceValue;
    const formatPriceLabel           = window.__xnPricing.formatPriceLabel;
    const buildPersonalisationLabels = window.__xnPricing.buildPersonalisationLabels;

    const XN_PREVIEW_IMAGES = {
        none: [
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_1.png?v=1788298949',
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_2.png?v=1788298950'
        ],
        one: [
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_1.png?v=1788298949',
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949'
        ],
        two: [
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949',
            'https://cdn.shopify.com/s/files/1/0909/4787/9256/files/unnamed_3_3.png?v=1788298949'
        ]
    };

    function generateGroupId() {
        return 'xn_grp_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    }

    function getRoot() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root : '/';
    }

    function getMainProductForm(target) {
        const form = target.closest && target.closest('form[action*="/cart/add"]');
        if (form) return form;
        return document.querySelector('form[action*="/cart/add"]');
    }

    function getCartElement() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function getCartSectionIds(cartElement) {
        if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
            try {
                return cartElement.getSectionsToRender().map(s => s.id);
            } catch (e) { /* fall through */ }
        }
        return ['cart-drawer', 'cart-icon-bubble'];
    }

    async function refreshCartIconBubble() {
        try {
            const res = await fetch(getRoot() + '?sections=cart-icon-bubble');
            const sections = await res.json();
            const bubbleWrapper = document.getElementById('cart-icon-bubble');
            if (bubbleWrapper && sections['cart-icon-bubble']) {
                const dom = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                const fresh = dom.getElementById('cart-icon-bubble');
                if (fresh) bubbleWrapper.innerHTML = fresh.innerHTML;
            }
        } catch (e) { /* non-critical */ }
    }

    function normalizeEngravingValue(value) {
        return String(value || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n')
            .split('\n').slice(0, 2)
            .map(line => line.slice(0, 16))
            .join('\n');
    }

    function getEngravingCountText(value) {
        const lines = normalizeEngravingValue(value).split('\n');
        const l1 = lines[0] ? lines[0].length : 0;
        const l2 = lines[1] ? lines[1].length : 0;
        return lines.length > 1 ? l1 + '/16 · ' + l2 + '/16' : l1 + ' / 16';
    }

    function resetAutoFitText(textEl) {
        if (!textEl) return;
        textEl.style.fontSize   = '';
        textEl.style.lineHeight = '';
    }

    function autoFitMetalTagText(textEl) {
        if (!textEl) return;
        const tag = textEl.closest('.xn-addon-box__metal-tag');
        if (!tag) return;
        resetAutoFitText(textEl);
        const text            = textEl.textContent || '';
        const isPlaceholder   = textEl.classList.contains('is-placeholder');
        const lines           = text.split('\n');
        const hasTwoLines     = lines.length > 1;
        const longestLen      = lines.reduce((max, l) => Math.max(max, l.length), 0);
        let fontSize          = isPlaceholder ? 8 : 34;
        const minFontSize     = isPlaceholder ? 6 : 7;
        if (hasTwoLines) fontSize = isPlaceholder ? 8 : 33;
        if (!isPlaceholder && longestLen > 10) {
            fontSize = hasTwoLines ? Math.floor(fontSize * 0.82) : Math.floor(fontSize * 0.7);
        }
        textEl.style.fontSize   = fontSize + 'px';
        textEl.style.lineHeight = hasTwoLines ? '1.18' : '1';
        let guard = 0;
        while (
            guard < 100 && fontSize > minFontSize &&
            (textEl.scrollWidth > textEl.clientWidth || textEl.scrollHeight > tag.clientHeight * 0.72)
        ) { fontSize -= 1; textEl.style.fontSize = fontSize + 'px'; guard++; }
    }

    function autoFitAllMetalTagTexts() {
        document.querySelectorAll('.xn-addon-box__metal-tag-text[data-xn-autofit]')
            .forEach(autoFitMetalTagText);
    }

    function createMetalTagPreview(options) {
        const { label = '', text = '', isPlaceholder = false, bgImage = '', showText = false } = options;
        const wrap = document.createElement('div');
        wrap.className      = 'xn-addon-box__metal-tag-wrap';
        wrap.style.flex     = '1 1 0';
        wrap.style.minWidth = '0';
        if (label) {
            const labelEl       = document.createElement('p');
            labelEl.className   = 'xn-addon-box__metal-tag-label';
            labelEl.textContent = label;
            wrap.appendChild(labelEl);
        }
        const tag = document.createElement('div');
        tag.className = 'xn-addon-box__metal-tag';
        if (bgImage) {
            tag.style.backgroundImage    = 'url(' + bgImage + ')';
            tag.style.backgroundSize     = 'cover';
            tag.style.backgroundPosition = 'center';
            tag.style.backgroundRepeat   = 'no-repeat';
        }
        if (showText) {
            const textEl = document.createElement('p');
            textEl.className = 'xn-addon-box__metal-tag-text';
            textEl.setAttribute('data-xn-autofit', 'true');
            if (isPlaceholder) textEl.classList.add('is-placeholder');
            textEl.textContent = text;
            tag.appendChild(textEl);
            window.requestAnimationFrame(() => autoFitMetalTagText(textEl));
        }
        wrap.appendChild(tag);
        return wrap;
    }

    function parseVariantId(value) {
        const id = Number(value);
        return (!value || Number.isNaN(id) || id <= 0) ? null : id;
    }

    function getSelectedPersonalisation() {
        const box = document.getElementById('personalisationBox');
        if (!box) return null;
        const selected = box.querySelector('input[name="personalisation_option"]:checked');
        if (!selected) return null;
        const mode = selected.dataset.mode || 'none';
        if (mode === 'none') return null;
        const selectedVariantId = parseVariantId(selected.value);
        if (!selectedVariantId) {
            box.classList.add('has-error');
            throw new Error('The selected personalisation option is not available. Please refresh the page or choose another option.');
        }
        const sideOneInput = document.getElementById('personalisationSideOneInput');
        const sideTwoInput = document.getElementById('personalisationSideTwoInput');
        const sideOneValue = sideOneInput ? normalizeEngravingValue(sideOneInput.value).trim() : '';
        const sideTwoValue = sideTwoInput ? normalizeEngravingValue(sideTwoInput.value).trim() : '';
        if (mode === 'one' && !sideOneValue) {
            box.classList.add('has-error');
            if (sideOneInput) sideOneInput.focus();
            throw new Error('Please enter the engraving text.');
        }
        if (mode === 'two' && (!sideOneValue || !sideTwoValue)) {
            box.classList.add('has-error');
            if (!sideOneValue && sideOneInput) sideOneInput.focus();
            else if (sideTwoInput) sideTwoInput.focus();
            throw new Error('Please enter the engraving text for both sides.');
        }
        return {
            id:          selectedVariantId,
            title:       selected.dataset.title || 'Personalisation',
            price:       getPriceValue(selected.dataset.price),
            mode:        mode,
            sideOneText: sideOneValue,
            sideTwoText: sideTwoValue
        };
    }

    function getSelectedGift() {
        const box = document.getElementById('giftReadyBox');
        if (!box) return null;
        const selected = box.querySelector('input[name="gift_packaging_option"]:checked');
        if (!selected) return null;
        const selectedVariantId = parseVariantId(selected.value);
        if (!selectedVariantId) {
            box.classList.add('has-error');
            throw new Error('The selected gift packaging option is not available. Please refresh the page or choose another option.');
        }
        return {
            id:    selectedVariantId,
            title: selected.dataset.title || 'Gift Packaging',
            price: getPriceValue(selected.dataset.price)
        };
    }

    function renderPersonalisationPreview(preview, mode, sideOneValue, sideTwoValue) {
        preview.innerHTML = '';
        preview.style.cssText = 'display:flex;flex-direction:row;flex-wrap:nowrap;align-items:flex-start;justify-content:center;';
        if (mode === 'two') {
            preview.appendChild(createMetalTagPreview({ label: 'Side 1', text: sideOneValue || 'Side 1 engraving', isPlaceholder: !sideOneValue, bgImage: XN_PREVIEW_IMAGES.two[0], showText: true }));
            preview.appendChild(createMetalTagPreview({ label: 'Side 2', text: sideTwoValue || 'Side 2 engraving', isPlaceholder: !sideTwoValue, bgImage: XN_PREVIEW_IMAGES.two[1], showText: true }));
        } else if (mode === 'one') {
            preview.appendChild(createMetalTagPreview({ label: 'Original side', bgImage: XN_PREVIEW_IMAGES.one[0], showText: false }));
            preview.appendChild(createMetalTagPreview({ label: 'Your engraving', text: sideOneValue || 'Side 1 engraving', isPlaceholder: !sideOneValue, bgImage: XN_PREVIEW_IMAGES.one[1], showText: true }));
        } else {
            preview.appendChild(createMetalTagPreview({ bgImage: XN_PREVIEW_IMAGES.none[0], showText: false }));
            preview.appendChild(createMetalTagPreview({ bgImage: XN_PREVIEW_IMAGES.none[1], showText: false }));
        }
        window.requestAnimationFrame(autoFitAllMetalTagTexts);
    }

    function updatePersonalisationUi() {
        const box = document.getElementById('personalisationBox');
        if (!box) return;
        const selected      = box.querySelector('input[name="personalisation_option"]:checked');
        const mode          = selected ? (selected.dataset.mode || 'none') : 'none';
        const sideOneInput  = document.getElementById('personalisationSideOneInput');
        const sideTwoInput  = document.getElementById('personalisationSideTwoInput');
        const sideOneCount  = document.getElementById('personalisationSideOneCount');
        const sideTwoCount  = document.getElementById('personalisationSideTwoCount');
        const sideOneField  = document.getElementById('personalisationSideOneField');
        const sideTwoField  = document.getElementById('personalisationSideTwoField');
        const preview       = document.getElementById('personalisationPreview');
        if (sideOneInput) {
            const n = normalizeEngravingValue(sideOneInput.value);
            if (sideOneInput.value !== n) sideOneInput.value = n;
        }
        if (sideTwoInput) {
            const n = normalizeEngravingValue(sideTwoInput.value);
            if (sideTwoInput.value !== n) sideTwoInput.value = n;
        }
        const sideOneValue = sideOneInput ? sideOneInput.value.trim() : '';
        const sideTwoValue = sideTwoInput ? sideTwoInput.value.trim() : '';
        box.classList.toggle('has-engraving',       mode === 'one' || mode === 'two');
        box.classList.toggle('is-default-selected', mode === 'none');
        box.classList.remove('has-error');
        box.querySelectorAll('.xn-choice-card').forEach(card => {
            const radio = card.querySelector('input[name="personalisation_option"]');
            card.classList.toggle('is-selected', !!(radio && radio.checked));
        });
        if (sideOneField) sideOneField.style.display = (mode === 'one' || mode === 'two') ? 'block' : 'none';
        if (sideTwoField) sideTwoField.style.display = mode === 'two' ? 'block' : 'none';
        if (sideOneCount) sideOneCount.textContent = getEngravingCountText(sideOneInput ? sideOneInput.value : '');
        if (sideTwoCount) sideTwoCount.textContent = getEngravingCountText(sideTwoInput ? sideTwoInput.value : '');
        if (preview) renderPersonalisationPreview(preview, mode, sideOneValue, sideTwoValue);
    }

    function updateGiftUi() {
        const box = document.getElementById('giftReadyBox');
        if (!box) return;
        box.classList.remove('has-error');
        const selected = box.querySelector('input[name="gift_packaging_option"]:checked');
        box.classList.toggle('is-default-selected', !!(selected && selected.dataset.default === 'true'));
        box.querySelectorAll('.xn-gift-card').forEach(card => {
            const radio = card.querySelector('input[name="gift_packaging_option"]');
            card.classList.toggle('is-selected', !!(radio && radio.checked));
        });
    }

    function initAddonUi() {
        const box     = document.getElementById('personalisationBox');
        const giftBox = document.getElementById('giftReadyBox');
        if (box) {
            box.querySelectorAll('input[name="personalisation_option"]').forEach(radio => {
                if (!radio.dataset.xnBound) {
                    radio.dataset.xnBound = 'true';
                    radio.addEventListener('change', updatePersonalisationUi);
                }
            });
        }
        ['personalisationSideOneInput', 'personalisationSideTwoInput'].forEach(id => {
            const input = document.getElementById(id);
            if (input && !input.dataset.xnBound) {
                input.dataset.xnBound = 'true';
                input.addEventListener('input', updatePersonalisationUi);
            }
        });
        if (giftBox) {
            giftBox.querySelectorAll('input[name="gift_packaging_option"]').forEach(radio => {
                if (!radio.dataset.xnBound) {
                    radio.dataset.xnBound = 'true';
                    radio.addEventListener('change', updateGiftUi);
                }
            });
        }
        updatePersonalisationUi();
        updateGiftUi();
        autoFitAllMetalTagTexts();
    }
    document.addEventListener('DOMContentLoaded', initAddonUi);
    initAddonUi();
    window.addEventListener('resize', () => window.requestAnimationFrame(autoFitAllMetalTagTexts));

    document.addEventListener('submit', async function(event) {
        const productForm = getMainProductForm(event.target);
        if (!productForm || event.target !== productForm) return;
        let selectedPersonalisation = null;
        let selectedGift = null;
        try {
            selectedPersonalisation = getSelectedPersonalisation();
            selectedGift            = getSelectedGift();
        } catch (validationError) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (validationError && validationError.message) alert(validationError.message);
            return;
        }
        if (!selectedPersonalisation && !selectedGift) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (productForm.dataset.addonsSubmitting === 'true') return;
        productForm.dataset.addonsSubmitting = 'true';
        try {
            const formData      = new FormData(productForm);
            const mainVariantId = parseVariantId(formData.get('id'));
            const quantity      = parseInt(formData.get('quantity') || '1', 10);
            if (!mainVariantId) throw new Error('Missing main product variant.');

            const groupId = generateGroupId();

            const mainProperties = {};
            if (selectedPersonalisation) {
                Object.assign(mainProperties, buildPersonalisationLabels({
                    title:       selectedPersonalisation.title,
                    mode:        selectedPersonalisation.mode,
                    unitPrice:   selectedPersonalisation.price,
                    quantity:    quantity,
                    sideOneText: selectedPersonalisation.sideOneText,
                    sideTwoText: selectedPersonalisation.sideTwoText
                }));
                mainProperties['_xn_personalisation_unit_price'] = String(selectedPersonalisation.price);
                mainProperties['_xn_personalisation_title']      = selectedPersonalisation.title;
                mainProperties['_xn_personalisation_mode']       = selectedPersonalisation.mode;
                mainProperties['_xn_side_one_text']              = selectedPersonalisation.sideOneText || '';
                mainProperties['_xn_side_two_text']              = selectedPersonalisation.sideTwoText || '';
            }
            if (selectedGift) {
                mainProperties['Gift Packaging']      = selectedGift.title + formatPriceLabel(selectedGift.price * quantity);
                mainProperties['_xn_gift_unit_price'] = String(selectedGift.price);
                mainProperties['_xn_gift_title']      = selectedGift.title;
            }
            mainProperties['_xn_group_id'] = groupId;

            const items = [{ id: mainVariantId, quantity, properties: mainProperties }];
            if (selectedPersonalisation) {
                items.push({
                    id:         selectedPersonalisation.id,
                    quantity,
                    properties: {
                        '_Add-on for variant':     String(mainVariantId),
                        '_Add-on type':            'Personalisation',
                        '_Personalisation option': selectedPersonalisation.title,
                        '_Side 1 Text':            selectedPersonalisation.sideOneText || '',
                        '_Side 2 Text':            selectedPersonalisation.sideTwoText || '',
                        '_xn_group_id':            groupId
                    }
                });
            }
            if (selectedGift) {
                items.push({
                    id:         selectedGift.id,
                    quantity,
                    properties: {
                        '_Add-on for variant': String(mainVariantId),
                        '_Add-on type':        'Gift Packaging',
                        '_Gift packaging':     selectedGift.title,
                        '_xn_group_id':        groupId
                    }
                });
            }
            const cartElement = getCartElement();
            const requestBody = {
                items,
                sections:     getCartSectionIds(cartElement),
                sections_url: window.location.pathname
            };
            if (cartElement && typeof cartElement.setActiveElement === 'function') {
                cartElement.setActiveElement(document.activeElement);
            }
            const response = await fetch(getRoot() + 'cart/add.js', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body:    JSON.stringify(requestBody)
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.description || 'Could not add selected options to cart.');
            }
            const responseJson = await response.json();
            if (cartElement && typeof cartElement.renderContents === 'function') {
                if (cartElement.classList.contains('is-empty')) cartElement.classList.remove('is-empty');
                cartElement.renderContents(responseJson);
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source:           'product-form',
                        productVariantId: mainVariantId,
                        cartData:         responseJson
                    });
                }
            } else {
                await refreshCartIconBubble();
                window.location.href = getRoot() + 'cart';
            }
        } catch (error) {
            console.error('XN add-ons error:', error);
            alert(error.message || 'Something went wrong while adding the selected options.');
        } finally {
            productForm.dataset.addonsSubmitting = 'false';
        }
    }, true);

    // Cart page only: keep add-on rows below the main product rows.
    function moveCartAddonsToBottom() {
        const tbody = document.querySelector('#main-cart-items table.cart-items tbody');
        if (!tbody) return;
        const rows       = Array.from(tbody.querySelectorAll('tr.cart-item'));
        const normalRows = rows.filter(r => !r.classList.contains('xn-cart-addon-item'));
        const addonRows  = rows.filter(r =>  r.classList.contains('xn-cart-addon-item'));
        if (!addonRows.length) return;
        const desired = normalRows.concat(addonRows);
        if (desired.every((r, i) => r === rows[i])) return;
        desired.forEach(r => tbody.appendChild(r));
    }
    document.addEventListener('DOMContentLoaded', moveCartAddonsToBottom);
    moveCartAddonsToBottom();
    window.__xnMoveCartAddonsToBottom = moveCartAddonsToBottom; // reused by the qty/currency-sync module
    // v19: attach once, and retry on DOMContentLoaded — if this script loads
    // before the cart markup exists, the observer used to never attach and
    // add-on rows stayed in the wrong order after Dawn re-rendered the page.
    function attachAddonRowObserver() {
        const container = document.getElementById('main-cart-items');
        if (!container || container.dataset.xnRowObserverBound) return;
        container.dataset.xnRowObserverBound = 'true';
        new MutationObserver(() => window.requestAnimationFrame(moveCartAddonsToBottom))
            .observe(container, { childList: true, subtree: true });
    }
    attachAddonRowObserver();
    document.addEventListener('DOMContentLoaded', attachAddonRowObserver);
})();


// ---------------------------------------------------------------------
// Qty-sync + CURRENCY-sync — v20
//
// Keeps hidden add-on lines (Engraving Add-on / Gift Packaging Add-on)
// in step with their main product, and rewrites price-label properties
// whenever quantity, the active storefront currency, OR the set of
// items in the cart changes (including removals).
//
// v15: syncs are QUEUED, never dropped; add-on cleanup is one batched
//      /cart/update.js call keyed by line `key`.
// v16: orphaned add-on rows fade out instantly; total dims while syncing.
// v17: drawer rendered in place (no open(), no double render).
// v18: cart PAGE footer/total re-rendered, is-empty toggled, rows found by id.
// v19: currency wrapper works on the cart page; no-op syncs skipped.
// v20: sync now runs AFTER the theme's own cart request finishes (fetch hook),
//      theme event subscription binds late if needed, stale rows are
//      repainted, batch failure falls back to per-line removal.
// ---------------------------------------------------------------------
(function() {
    if (window.__xnQtySyncInstalled) return;
    window.__xnQtySyncInstalled = true;

    const formatPriceLabel           = window.__xnPricing.formatPriceLabel;
    const buildPersonalisationLabels = window.__xnPricing.buildPersonalisationLabels;

    function getRoot() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root : '/';
    }
    function getCartElement() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }
    // v20: our own cart writes bypass the fetch hook so they never re-trigger a sync.
    const xnFetch = window.__xnOrigFetch || window.fetch.bind(window);

    // Lightweight CSS for the optimistic fade + the "syncing" dimming.
    function injectXnSyncStyles() {
        if (document.getElementById('xn-sync-styles')) return;
        const style = document.createElement('style');
        style.id = 'xn-sync-styles';
        style.textContent =
            '.xn-row-removing{opacity:0!important;transition:opacity .18s ease;pointer-events:none;}' +
            '.xn-row-removing.xn-row-hidden{display:none!important;}' +
            '.xn-total-syncing{opacity:.45;transition:opacity .15s ease;}';
        document.head.appendChild(style);
    }

    // Best-effort selectors for the on-page estimated-total element(s).
    function getTotalElements() {
        return Array.from(document.querySelectorAll(
            '.totals__total-value, .cart__footer .totals__total-value, ' +
            '.drawer__footer .totals__total-value, [data-cart-total], .cart-total, .cart__total'
        ));
    }
    function setTotalSyncing(active) {
        getTotalElements().forEach(el => el.classList.toggle('xn-total-syncing', active));
    }

    // v18: find rows by their own id (CartItem-N on the page, CartDrawer-Item-N
    // in the drawer). Those ids follow the cart line index and don't change
    // when moveCartAddonsToBottom() reorders the DOM. The title is verified as
    // well so a stale DOM can never fade the wrong row.
    function markOrphanAddonRowsAsRemoving(cartData) {
        if (!cartData || !Array.isArray(cartData.items)) return;
        cartData.items.forEach(function(item, idx) {
            if (!isAddonItem(item)) return;
            if (findMainItem(cartData.items, item)) return; // not an orphan
            const n = idx + 1;
            ['CartItem-' + n, 'CartDrawer-Item-' + n].forEach(function(id) {
                const row = document.getElementById(id);
                if (!row) return;
                const t = row.getAttribute('item_title');
                if (t && item.product_title && t !== item.product_title) return;
                row.classList.add('xn-row-removing');
                // v19: table rows ignore max-height, so collapse after the fade
                setTimeout(function() { row.classList.add('xn-row-hidden'); }, 200);
            });
        });
    }

    async function postCartChange(payload, sectionIds) {
        const res = await xnFetch(getRoot() + 'cart/change.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body:    JSON.stringify(Object.assign({}, payload, { sections: sectionIds, sections_url: window.location.pathname }))
        });
        const data = await res.json();
        if (!res.ok) throw new Error((data && data.description) || 'cart/change.js request failed');
        return data;
    }

    // Batched multi-line quantity update, keyed by line `key`. Also used with
    // an EMPTY updates object as a cheap way to re-fetch a consistent cart
    // (with rendered sections) after parallel writes.
    async function postCartUpdateBatch(updatesByKey, sectionIds) {
        const res = await xnFetch(getRoot() + 'cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body:    JSON.stringify({ updates: updatesByKey, sections: sectionIds, sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error((data && data.description) || 'cart/update.js request failed');
        return data;
    }

    async function fetchCart() {
        const res  = await fetch(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (!res.ok) throw new Error('cart.js request failed');
        return data;
    }

    function getSectionIdForElement(el) {
        if (!el) return null;
        if (el.dataset && el.dataset.id) return el.dataset.id;
        const wrapper = el.closest('[id^="shopify-section-"]');
        if (wrapper) return wrapper.id.replace('shopify-section-', '');
        return null;
    }
    function getMainCartItemsSectionId() {
        return getSectionIdForElement(document.getElementById('main-cart-items'));
    }
    // v18: the cart page's footer (total) is a separate section.
    function getMainCartFooterSectionId() {
        return getSectionIdForElement(document.getElementById('main-cart-footer'));
    }

    function getCartSectionIds(cartElement) {
        let ids = [];
        if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
            try {
                ids = cartElement.getSectionsToRender().map(s => s.id).filter(Boolean);
            } catch (e) { /* fall through */ }
        }
        if (ids.indexOf('cart-icon-bubble') === -1) ids.push('cart-icon-bubble');
        // v18: the cart PAGE needs BOTH its items section and its footer section
        [getMainCartItemsSectionId(), getMainCartFooterSectionId()].forEach(function(id) {
            if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        return ids;
    }

    function parseHtml(html) {
        return new DOMParser().parseFromString(html, 'text/html');
    }

    function renderIconBubble(cartResponse) {
        const html = cartResponse.sections && cartResponse.sections['cart-icon-bubble'];
        const el   = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        const fresh = parseHtml(html).querySelector('.shopify-section');
        if (fresh) el.innerHTML = fresh.innerHTML;
    }

    // Render the cart drawer's sections IN PLACE — what Dawn's
    // cart-drawer.renderContents() does to the DOM, minus the open() call.
    function renderDrawerSectionsInPlace(cartElement, cartResponse) {
        let sections = [];
        try { sections = cartElement.getSectionsToRender() || []; } catch (e) { sections = []; }
        if (!sections.length || !cartResponse.sections) return false;
        let rendered = false;
        sections.forEach(section => {
            const html = cartResponse.sections[section.id];
            if (!html) return;
            const target = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            if (!target) return;
            const doc    = parseHtml(html);
            const source = section.selector
                ? doc.querySelector(section.selector)
                : doc.querySelector('.shopify-section');
            if (!source) return;
            target.innerHTML = source.innerHTML;
            rendered = true;
        });
        if (rendered) {
            // Dawn binds "click overlay to close" inside renderContents();
            // since we bypass it, re-bind on the freshly rendered overlay.
            const overlay = cartElement.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof cartElement.close === 'function' && !overlay.dataset.xnCloseBound) {
                overlay.dataset.xnCloseBound = 'true';
                overlay.addEventListener('click', cartElement.close.bind(cartElement));
            }
        }
        return rendered;
    }

    // v18: re-render the standalone cart PAGE — items AND footer — and toggle
    // the is-empty state the way Dawn's own cart-items does.
    function renderCartPageSections(cartResponse) {
        const sections = cartResponse.sections || {};
        const isEmpty  = cartResponse.item_count === 0;
        let rendered   = false;

        const itemsEl = document.getElementById('main-cart-items');
        const itemsId = getMainCartItemsSectionId();
        if (itemsEl && itemsId && sections[itemsId]) {
            const fresh = parseHtml(sections[itemsId]).getElementById('main-cart-items');
            if (fresh) {
                itemsEl.innerHTML = fresh.innerHTML;
                rendered = true;
                window.requestAnimationFrame(function() {
                    if (typeof window.__xnMoveCartAddonsToBottom === 'function') window.__xnMoveCartAddonsToBottom();
                });
            }
        }

        const footerEl = document.getElementById('main-cart-footer');
        const footerId = getMainCartFooterSectionId();
        if (footerEl && footerId && sections[footerId]) {
            const freshFooter = parseHtml(sections[footerId]).getElementById('main-cart-footer');
            if (freshFooter) {
                const target = footerEl.querySelector('.js-contents');
                const source = freshFooter.querySelector('.js-contents');
                if (target && source) target.innerHTML = source.innerHTML;
                else footerEl.innerHTML = freshFooter.innerHTML;
                rendered = true;
            }
        }

        if (rendered) {
            const cartItemsTag = document.querySelector('cart-items');
            if (cartItemsTag) cartItemsTag.classList.toggle('is-empty', isEmpty);
            if (footerEl) footerEl.classList.toggle('is-empty', isEmpty);
        }
        return rendered;
    }

    // Returns true when something was rendered in place (drawer and/or page),
    // which runSyncOnce uses to publish the event as 'cart-items' (no refetch).
    function renderCartSections(cartElement, cartResponse) {
        if (!cartResponse || typeof cartResponse.item_count === 'undefined') return false;
        const isEmpty    = cartResponse.item_count === 0;
        const onCartPage = !!document.getElementById('main-cart-items');
        let renderedInPlace = false;
        let drawerRendered  = false;

        if (cartElement && cartElement.tagName === 'CART-DRAWER') {
            drawerRendered = renderDrawerSectionsInPlace(cartElement, cartResponse);
            if (drawerRendered) {
                cartElement.classList.toggle('is-empty', isEmpty);
                renderedInPlace = true;
            } else if (!onCartPage && typeof cartElement.renderContents === 'function') {
                cartElement.classList.toggle('is-empty', isEmpty);
                cartElement.renderContents(cartResponse);
            }
        }
        // v18: never call cart-notification.renderContents() here — it calls
        // open() and pops the notification up on every sync. Icon bubble only.

        if (renderCartPageSections(cartResponse)) renderedInPlace = true;
        if (!drawerRendered) renderIconBubble(cartResponse);
        return renderedInPlace;
    }

    function isAddonItem(item) {
        return !!(item.properties && (item.properties['_Add-on type'] || item.properties['_Add-on for variant']));
    }

    function findMainItem(items, addonItem) {
        const props = (addonItem && addonItem.properties) || {};
        const groupId = props['_xn_group_id'];
        if (groupId) {
            return items.find(mi =>
                !isAddonItem(mi) &&
                mi.properties &&
                mi.properties['_xn_group_id'] === groupId
            );
        }
        const linkedVariantId = props['_Add-on for variant'];
        return items.find(mi => String(mi.variant_id) === String(linkedVariantId) && !isAddonItem(mi));
    }

    function findAddonItemsForMain(items, mainItem) {
        const groupId = mainItem.properties && mainItem.properties['_xn_group_id'];
        if (groupId) {
            return items.filter(it => isAddonItem(it) && it.properties && it.properties['_xn_group_id'] === groupId);
        }
        return items.filter(it =>
            isAddonItem(it) &&
            it.properties &&
            String(it.properties['_Add-on for variant']) === String(mainItem.variant_id)
        );
    }

    function getLiveUnitPrice(addonItem) {
        if (!addonItem) return 0;
        if (typeof addonItem.final_price === 'number') {
            return addonItem.final_price / 100;
        }
        if (addonItem.final_line_price && addonItem.quantity) {
            return (addonItem.final_line_price / addonItem.quantity) / 100;
        }
        return 0;
    }

    function getUpdatedPropertiesIfNeeded(item, addonItems) {
        const rawProps = item.properties || {};
        const props    = {};
        Object.keys(rawProps).forEach(k => {
            if (rawProps[k] !== null && rawProps[k] !== undefined) props[k] = rawProps[k];
        });
        let changed = false;
        const qty   = item.quantity;

        const personalisationAddon = addonItems.find(a => a.properties && a.properties['_Add-on type'] === 'Personalisation');
        const giftAddon            = addonItems.find(a => a.properties && a.properties['_Add-on type'] === 'Gift Packaging');

        if (props['_xn_personalisation_unit_price'] !== undefined) {
            const liveTotal     = personalisationAddon ? (personalisationAddon.final_line_price / 100) : null;
            const liveUnitPrice = personalisationAddon ? getLiveUnitPrice(personalisationAddon) : (parseFloat(props['_xn_personalisation_unit_price']) || 0);
            const title    = props['_xn_personalisation_title'] || '';
            const expected = props['_xn_personalisation_mode']
                ? buildPersonalisationLabels({
                    title,
                    mode:        props['_xn_personalisation_mode'],
                    total:       liveTotal !== null ? liveTotal : (liveUnitPrice * qty),
                    sideOneText: props['_xn_side_one_text'] || '',
                    sideTwoText: props['_xn_side_two_text'] || ''
                })
                : { 'Personalisation Option': title + formatPriceLabel(liveTotal !== null ? liveTotal : (liveUnitPrice * qty)) };
            Object.keys(expected).forEach(k => {
                if (props[k] !== expected[k]) { props[k] = expected[k]; changed = true; }
            });
            const liveUnitPriceStr = String(liveUnitPrice);
            if (props['_xn_personalisation_unit_price'] !== liveUnitPriceStr) {
                props['_xn_personalisation_unit_price'] = liveUnitPriceStr;
                changed = true;
            }
        }

        if (props['_xn_gift_unit_price'] !== undefined) {
            const liveTotal     = giftAddon ? (giftAddon.final_line_price / 100) : null;
            const liveUnitPrice = giftAddon ? getLiveUnitPrice(giftAddon) : (parseFloat(props['_xn_gift_unit_price']) || 0);
            const title    = props['_xn_gift_title'] || '';
            const expected = title + formatPriceLabel(liveTotal !== null ? liveTotal : (liveUnitPrice * qty));
            if (props['Gift Packaging'] !== expected) { props['Gift Packaging'] = expected; changed = true; }
            const liveUnitPriceStr = String(liveUnitPrice);
            if (props['_xn_gift_unit_price'] !== liveUnitPriceStr) {
                props['_xn_gift_unit_price'] = liveUnitPriceStr;
                changed = true;
            }
        }
        return changed ? props : null;
    }

    // v20: do the line-item rows on screen match the real cart?
    function isDomStale(cartData) {
        if (!cartData || !Array.isArray(cartData.items)) return false;
        const n = cartData.items.length;
        const selectors = ['#main-cart-items', '#CartDrawer-CartItems'];
        for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (!el) continue;
            if (el.querySelectorAll('tr.cart-item').length !== n) return true;
        }
        return false;
    }

    // One sync pass.
    //   Phase 1 — batch-fix add-on quantities/removals (one call).
    //   Phase 2 — price-label rewrites. ONE main item needing a rewrite is a
    //             single change.js call whose response is used directly.
    //             SEVERAL fire in parallel, then one cheap empty update pulls
    //             back a consistent cart (with sections).
    async function runSyncOnce(cartData, sourceTag) {
        if (!cartData || !Array.isArray(cartData.items)) return null;
        const cartElement = getCartElement();
        const sectionIds  = getCartSectionIds(cartElement);
        let currentCart = cartData;
        let didAnything = false;

        // Phase 1
        const updates = {};
        currentCart.items.forEach(function(item) {
            if (!isAddonItem(item)) return;
            const mainItem  = findMainItem(currentCart.items, item);
            const targetQty = mainItem ? mainItem.quantity : 0;
            if (targetQty !== item.quantity) {
                updates[item.key] = targetQty;
            }
        });
        if (Object.keys(updates).length) {
            try {
                currentCart = await postCartUpdateBatch(updates, sectionIds);
            } catch (e) {
                // v20: if the batched call is rejected, remove/fix the add-on
                // lines one by one (addressed by line key) instead of leaving them.
                console.error('XN batch add-on update failed, falling back to per-line:', e);
                for (const key of Object.keys(updates)) {
                    currentCart = await postCartChange({ id: key, quantity: updates[key] }, sectionIds);
                }
            }
            didAnything = true;
        }

        // Phase 2
        const propUpdates = [];
        for (const item of currentCart.items) {
            if (isAddonItem(item)) continue;
            const linkedAddons = findAddonItemsForMain(currentCart.items, item);
            const updatedProps = getUpdatedPropertiesIfNeeded(item, linkedAddons);
            if (updatedProps) propUpdates.push({ key: item.key, quantity: item.quantity, properties: updatedProps });
        }
        if (propUpdates.length === 1) {
            const u = propUpdates[0];
            try {
                currentCart = await postCartChange({ id: u.key, quantity: u.quantity, properties: u.properties }, sectionIds);
            } catch (e) {
                console.error('XN label rewrite failed, refetching cart:', e);
                currentCart = await postCartUpdateBatch({}, sectionIds);
            }
            didAnything = true;
        } else if (propUpdates.length > 1) {
            await Promise.allSettled(
                propUpdates.map(u => postCartChange({ id: u.key, quantity: u.quantity, properties: u.properties }, sectionIds))
            );
            currentCart = await postCartUpdateBatch({}, sectionIds);
            didAnything = true;
        }

        // v20: the theme may have re-rendered stale rows AFTER our render (e.g.
        // two quick removals). If the rows on screen don't match the real cart,
        // repaint from the real cart even though no data needed changing.
        if (!didAnything && isDomStale(currentCart)) {
            currentCart = await postCartUpdateBatch({}, sectionIds);
            didAnything = true;
        }

        if (didAnything) {
            const renderedInPlace = renderCartSections(cartElement, currentCart);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                // When already rendered, publish as 'cart-items' so Dawn's
                // cart-drawer-items / cart-items don't refetch and repaint a
                // second time. `xnSource` lets our own subscriber ignore it.
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source:   renderedInPlace ? 'cart-items' : (sourceTag || 'xn-qty-sync'),
                    xnSource: sourceTag || 'xn-qty-sync',
                    cartData: currentCart
                });
            }
        }
        return currentCart;
    }

    let xnSyncing         = false;
    let xnResyncRequested = false;

    let xnHookTimer = null;

    // v19: true only if the cart actually needs fixing (orphan/mismatched
    // add-on quantity, or a stale price label). Avoids dimming the total and
    // re-rendering the cart page on every ordinary cart update.
    function cartNeedsSync(cartData) {
        if (!cartData || !Array.isArray(cartData.items)) return false;
        const items = cartData.items;
        for (const item of items) {
            if (isAddonItem(item)) {
                const mainItem = findMainItem(items, item);
                const targetQty = mainItem ? mainItem.quantity : 0;
                if (targetQty !== item.quantity) return true;
            } else if (getUpdatedPropertiesIfNeeded(item, findAddonItemsForMain(items, item))) {
                return true;
            }
        }
        return false;
    }

    async function requestSync(cartData, sourceTag) {
        // Nothing to fix and nothing running -> do nothing at all.
        if (!xnSyncing && !cartNeedsSync(cartData) && !isDomStale(cartData)) return;

        // Instant visual feedback, before any network round trip.
        injectXnSyncStyles();
        markOrphanAddonRowsAsRemoving(cartData);
        setTotalSyncing(true);

        if (xnSyncing) {
            xnResyncRequested = true;
            return;
        }
        xnSyncing = true;
        try {
            await runSyncOnce(cartData, sourceTag);
            while (xnResyncRequested) {
                xnResyncRequested = false;
                try {
                    const latestCart = await fetchCart();
                    markOrphanAddonRowsAsRemoving(latestCart);
                    await runSyncOnce(latestCart, sourceTag);
                } catch (e) {
                    console.error('XN qty/currency-sync (queued pass) error:', e);
                }
            }
        } catch (err) {
            console.error('XN qty/currency-sync error:', err);
        } finally {
            xnSyncing = false;
            setTotalSyncing(false);
        }
    }

    // Recognise every event we published ourselves (any sourceTag).
    function isOwnSyncEvent(event) {
        if (!event) return false;
        if (event.xnSource) return true;
        return typeof event.source === 'string' && event.source.indexOf('xn-') === 0;
    }

    // React to the theme's cart events (add/update/remove).
    // v20: bind late if this script loaded before the theme's pubsub.js —
    // before, a too-early load meant this subscription silently never existed.
    let xnSubscribed = false;
    function bindThemeSubscription() {
        if (xnSubscribed) return true;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return false;
        xnSubscribed = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
            if (isOwnSyncEvent(event)) return;
            const cartData = event && event.cartData;
            if (!cartData) return;
            requestSync(cartData, 'xn-qty-sync');
        });
        return true;
    }
    if (!bindThemeSubscription()) {
        document.addEventListener('DOMContentLoaded', bindThemeSubscription);
        window.addEventListener('load', bindThemeSubscription);
        let tries = 0;
        const iv = setInterval(function() {
            if (bindThemeSubscription() || ++tries > 50) clearInterval(iv);
        }, 100);
    }

    // v20: runs when the theme's own cart request (remove / quantity / add)
    // has FINISHED (see the fetch hook at the top of this file). We then read
    // the real cart and remove/fix any add-on lines. Works even if the theme
    // doesn't publish cartUpdate, and can't run before the delete has landed.
    window.__xnOnThemeCartRequest = function() {
        clearTimeout(xnHookTimer);
        xnHookTimer = setTimeout(async function() {
            try {
                const cart = await fetchCart();
                await requestSync(cart, 'xn-fetch-hook');
            } catch (e) {
                console.error('XN cart-request sync error:', e);
            }
        }, 120);
    };

    // Also run once on page load — a country/currency switch (Shopify
    // Markets) is normally a full page reload, not a cartUpdate event.
    async function syncOnLoad() {
        try {
            const cart = await fetchCart();
            if (cart && Array.isArray(cart.items) && cart.items.length) {
                await requestSync(cart, 'xn-currency-sync-onload');
            }
        } catch (e) {
            console.error('XN on-load currency-sync error:', e);
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncOnLoad);
    } else {
        syncOnLoad();
    }

    // v20: the old click-on-remove-button / quantity-change timer fallback was
    // removed. It started a sync 250ms after the click — often BEFORE the
    // theme's delete request had finished — so it saw the old cart and never
    // removed the add-on lines. The fetch hook above replaces it.
})();


// ---------------------------------------------------------------------
// Custom PDP price display
// v18: guarded so a missing jQuery doesn't throw on pages (e.g. the cart
// page) where jQuery isn't loaded.
// ---------------------------------------------------------------------
if (window.jQuery) {
    jQuery(function ($) {
        const getPrice     = window.__xnPricing.getPriceValue;
        const formatAmount = window.__xnPricing.formatAmount;

        function getSelectedQuantity() {
            const qty = parseInt($('form[action*="/cart/add"] input[name="quantity"]').first().val(), 10);
            return (qty && qty > 0) ? qty : 1;
        }

        function updateTotalPrice() {
            const $priceElement = $(
                '.tmp-xnest-prod-page-2 .product__info-wrapper.grid__item .product__info-container .custom_product_price'
            );

            // Base (main product) price. Normally read from the personalisation
            // radios' pro-price. On the no-engraving template those radios aren't
            // rendered, so fall back to the gift radios' pro-price, then to the
            // container's data-xn-base-price — so it never drops to 0.
            let $baseOption = $('input[name="personalisation_option"]').first();
            if (!$baseOption.length) $baseOption = $('input[name="gift_packaging_option"]').first();
            let totalPrice = $baseOption.length ? getPrice($baseOption.attr('pro-price')) : 0;
            if (!totalPrice) {
                const baseAttr = $('.xn-make-yours').attr('data-xn-base-price');
                if (baseAttr) totalPrice = getPrice(baseAttr);
            }

            const $selPersonalisation = $('input[name="personalisation_option"]:checked').first();
            if ($selPersonalisation.length) {
                totalPrice += getPrice($selPersonalisation.attr('data-price'));
            }

            $('input[name="gift_packaging_option"]:checked').each(function () {
                totalPrice += getPrice($(this).attr('data-price'));
            });

            totalPrice *= getSelectedQuantity();

            const wrap = window.__xnPricing.parseCurrencyWrapper();
            const formatted = wrap.prefix + formatAmount(totalPrice) + (wrap.suffix ? ' ' + wrap.suffix : '');
            $priceElement.text(formatted);
        }

        $('input[name="personalisation_option"]').on('change', updateTotalPrice);
        $('input[name="gift_packaging_option"]').on('change',  updateTotalPrice);
        $(document).on('change input', 'form[action*="/cart/add"] input[name="quantity"]', updateTotalPrice);
        updateTotalPrice();
    });
}